/* eslint-disable max-len */
import update from 'immutability-helper';
import moment from 'moment-timezone';
import { v4 as uuidv4 } from 'uuid';
import generateUniqueId from '../../../shared/utils/generateUniqueId';
import { getMonthViewWindowStart } from '../utils/monthViewWindow';
import getCalendarSelectionKey from '../utils/getCalendarSelectionKey';
import { resolveEntryViewType } from '../utils/buildDefaultView';
import {
  FETCH_CAL_WORKOUT_CALENDAR_FULFILLED,
  FETCH_CAL_WORKOUT_CALENDAR_REJECTED,
  FETCH_CAL_WORKOUT_CALENDAR_START,
  SET_ACTIVE_MODAL,
  SET_ACTIVE_SECOND_LAYER_MODAL,
  SET_SWAP_DROPDOWN_TOGGLE_ENABLED,
  SET_IS_PRIMARY_ANIMATED_SIDE_BAR_OPEN,
  FETCH_CALENDAR_ACTION_HISTORY_START,
  FETCH_CALENDAR_ACTION_HISTORY_FULFILLED,
  FETCH_CALENDAR_ACTION_HISTORY_REJECTED,
  SET_SELECTED_HISTORY_ENTRY_ID,
  RECORD_GESTURE_PARTICIPANT_COUNT,
  SET_IS_CALENDAR_OPTIONS_DROPDOWN_MENU_OPEN,
  SET_IS_STATIC_ADD_COLUMN_DROPDOWN_MENU_OPEN,
  SET_IS_SUPERSET_PICKER_OPEN,
  SET_SUPERSET_PICKER_OPEN_BY_ID,
  REMOVE_SUPERSET_PICKER_OPEN_BY_ID,
  SET_PRIMARY_SIDE_BAR_DATA_TAG,
  SET_SECONDARY_SIDE_BAR_DATA_TAG,
  SET_SELECTED_REDUX_CALENDAR,
  SET_SELECTED_REDUX_NON_DATE_BASED_PROGRAM,
  SET_SELECTED_SAVED_WORKOUT,
  SET_IS_CLONE_DRAGGING,
  SET_HEADER_HEIGHT,
  FETCH_ALL_EXERCISES_START,
  FETCH_ALL_EXERCISES_FULFILLED,
  FETCH_ALL_EXERCISES_REJECTED,
  SET_SELECTED_DATE,
  SET_SELECTED_PROGRAM_DAY_NUMBER,
  SET_SELECTED_MONTH,
  SET_FIRST_MONTH_IN_PICKER,
  SET_MONTH_VIEW_WINDOW_START,
  CENTER_MONTH_VIEW_ON_FOCUS,
  REFETCH_MONTH_VIEW_ITEMS,
  REQUEST_MONTH_VIEW_MONTH_NAV,
  SET_SIDE_BAR_EXERCISES_SEARCH_TERM,
  FETCH_CALENDAR_ITEMS_START,
  FETCH_CALENDAR_ITEMS_FULFILLED,
  FETCH_CALENDAR_ITEMS_REJECTED,
  FETCH_RECURRING_CALENDAR_ITEMS_FULFILLED,
  SET_COMBINE_WITH_ID,
  SET_SUPERSET_PICKER,
  SET_CALENDAR_PANEL_CONTAINER_WIDTH,
  SET_ANIMATED_SIDEBAR_CONTAINER_WIDTH,
  SET_SELECTED_ITEMS,
  SET_SELECTED_ITEM,
  REMOVE_SELECTED_ITEM,
  SET_MONTH_SELECTION_ACTIVE_DATE,
  SET_COPIED_SELECTED_ITEMS,
  SET_EXPANDED_ITEMS,
  SET_EXPANDED_ITEM,
  REMOVE_EXPANDED_ITEM,
  SET_SESSION_BREAK_COLLAPSED,
  SET_WEEK_VIEW_EXPANDED_DAY,
  SET_ACTIVE_EXERCISE_ID,
  START_NEW_EDIT_BATCH,
  FOCUS_NEXT_PRESAVE_ITEM,
  FOCUS_NEXT_PRESAVE_PROGRAM_ITEM,
  SAVE_CALENDAR_EXERCISE_FULFILLED,
  SAVE_CALENDAR_EXERCISE_REJECTED,
  SAVE_NON_DATE_BASED_WORKOUT_EXERCISE_FULFILLED,
  // SAVE_NON_DATE_BASED_WORKOUT_EXERCISE_REJECTED,
  SET_CALENDAR_CONTAINER_SCROLL_POSITION,
  SET_ADD_INFO_CONTENT,
  SET_IFRAMELY_ERROR,
  UPLOAD_CALENDAR_MEDIA_FULFILLED,
  UPLOAD_CALENDAR_MEDIA_REJECTED,
  // UPLOAD_MEDIA_BY_URL_START,
  // UPLOAD_MEDIA_BY_URL_FULFILLED,
  // EDIT_THUMBNAIL_START,
  EDIT_THUMBNAIL_FULFUILLED,
  // EDIT_THUMBNAIL_REJECTED,
  CREATE_EXERCISE_FULFILLED,
  FETCH_DOCUMENTS_FULFILLED,
  FETCH_DOCUMENT_FULFILLED,
  FETCH_FOLDER_FULFILLED,
  ADD_ASSET,
  FETCH_PARENT_CALENDARS_FULFILLED,
  FETCH_PARENT_CALENDARS_REJECTED,
  FETCH_CALENDAR_SELECT_ATHLETES_START,
  FETCH_CALENDAR_SELECT_ATHLETES_FULFILLED,
  FETCH_CALENDAR_SELECT_ATHLETES_REJECTED,
  SET_CLICKED_UPGRADE_NOW,
  SET_NEW_PRESAVE_ITEM_FROM_CREATE_EXERCISE_FORM,
  UPDATE_PROGRAMMED_CALENDAR_ITEM_FULFILLED,
  UPDATE_PROGRAMMED_CALENDAR_ITEM_REJECTED,
  UPDATE_CALENDAR_ITEMS_ORDER_FULFILLED,
  UPDATE_FUTURE_OCCURRENCES_PROGRAMMED_CALENDAR_ITEM_FULFILLED,
  UPDATE_SAVED_WORKOUT_ITEM_FULFILLED,
  SWAP_PROGRAMMED_ITEM_ON_CHILD_CALENDAR_FULFILLED,
  REVERT_SWAPPED_ITEM_FULFILLED,
  CREATE_TAG_FOR_ACCOUNT_FULTILLED,
  FETCH_ACCOUNT_TAGS_FULFILLED,
  UPDATE_TAG_FOR_ACCOUNT_FULFILLED,
  DELETE_TAGS_FOR_ACCOUNT_FULFILLED,
  CREATE_PROGRAM_TAG_FULFILLED,
  FETCH_PROGRAM_TAGS_FULFILLED,
  UPDATE_PROGRAM_TAG_FULFILLED,
  DELETE_PROGRAM_TAGS_FULFILLED,
  ADD_PRESAVED_ITEM_TO_CALENDAR_ITEMS_ARRAY,
  ADD_PRESAVED_ITEM_TO_PROGRAM_ITEMS_ARRAY,
  UPDATE_PRESAVED_CALENDAR_ITEM,
  UPDATE_PRESAVED_PROGRAM_ITEM,
  SET_ON_BEFORE_CAPTURE,
  SET_CALENDAR_CONTENT_SCROLL_CONTAINER_TOP_POSITION,
  REMOVE_PRESAVE_ITEM_FROM_REDUX,
  REMOVE_PRESAVE_PROGRAM_ITEM_FROM_REDUX,
  CLEAR_PRE_SAVE_ITEMS,
  LOG_REDUX_PRESAVE_ADD_INFO,
  LOG_REDUX_PRESAVE_DESCRIPTION,
  FETCH_QUESTIONS_FOR_ACCOUNT_CALENDAR_FULFILLED,
  CREATE_QUESTION_FOR_ACCOUNT_FULTILLED,
  CLEAR_NEWLY_CREATED_QUESTION,
  SET_QUESTION_COUNT,
  SET_DELETE_STACK,
  SET_SELECTED_REDUX_ATHLETE,
  SET_CALENDAR_ITEMS,
  SET_NON_DATE_BASED_PROGRAM_ITEMS,
  SET_NON_DATE_BASED_PROGRAM_DAYS,
  SET_RECURRING_CALENDAR_ITEMS,
  CLEAR_BEFORE_RECURRING_CALENDAR_ITEMS,
  CLEAR_AFTER_RECURRING_CALENDAR_ITEMS,
  CLEAR_CALENDAR_ITEMS,
  CLEAR_NON_DATE_BASED_PROGRAM_ITEMS,
  DELETE_SAVED_CALENDAR_ITEM_FULFILLED,
  DELETE_SAVED_WORKOUT_ITEM_FULFILLED,
  UNDO_DELETE_SAVED_WORKOUT_ITEM_FULFILLED,
  UNDO_DELETE_SAVED_CALENDAR_ITEM_FULFILLED,
  CONVERT_RECURRING_ITEM_FULFILLED,
  DELETE_RECURRING_ITEM_FULFILLED,
  UPDATE_RECURRING_ITEM_SCHEDULE_FULFILLED,
  SET_IS_DRAGGING,
  SET_DRAG_SOURCE,
  SET_DRAGGED_ITEM,
  SET_REDUX_CALENDAR_CONTAINERS,
  SET_PROGRAMMED_CALENDAR_ITEMS,
  MULTI_MOVE_EXERCISE_BETWEEN_DATES_FULFILLED,
  MOVE_NON_DATE_BASED_EXERCISE_BETWEEN_DAYS_FULFILLED,
  FETCH_SAVED_WORKOUTS_FULFILLED,
  FETCH_SAVED_WORKOUT_DETAIL_START,
  FETCH_SAVED_WORKOUT_DETAIL_FULFILLED,
  FETCH_SAVED_WORKOUT_DETAIL_REJECTED,
  FETCH_SAVED_WORKOUT_FULFILLED,
  SET_COMBINE_WITH_INFO,
  SET_LAST_UPDATE_TIME,
  UPDATE_WORKOUT_INFO_NAME_FULFILLED,
  UPDATE_WORKOUT_INFO_COLOR_FULFILLED,
  UPDATE_NON_DATE_BASED_WORKOUT_INFO_NAME_FULFILLED,
  SAVE_WORKOUT_TEMPLATE_FULFILLED,
  SHARE_WORKOUT_INFO_START,
  SHARE_WORKOUT_INFO_FULFILLED,
  SHARE_WORKOUT_INFO_REJECTED,
  REVERT_LAST_KNOWN_CORRECT_ORDER,
  REVERT_LAST_KNOWN_CORRECT_ORDER_FOR_SAVED_WORKOUT,
  FETCH_CALENDAR_PICKER_ITEMS_START,
  FETCH_CALENDAR_PICKER_ITEMS_FULFILLED,
  FETCH_CALENDAR_PICKER_ITEMS_REJECTED,
  FETCH_AND_SET_DEFAULT_CALENDAR_FULFILLED,
  FETCH_AND_SET_URL_ATHLETE_FULFILLED,
  FETCH_AND_SET_URL_CALENDAR_FULFILLED,
  FETCH_AND_SET_URL_CHILD_CALENDAR_FULFILLED,
  FETCH_AND_SET_URL_PROGRAM_FULFILLED,
  FETCH_EXERCISE_FULFILLED,
  FETCH_EXERCISE_REJECTED,
  SET_EXERCISE_PICKER_SEARCH_TERM,
  CREATE_PARENT_CALENDAR_START,
  CREATE_PARENT_CALENDAR_FULFILLED,
  CREATE_PARENT_CALENDAR_REJECTED,
  CREATE_A_SAVED_WORKOUT_START,
  CREATE_A_SAVED_WORKOUT_FULFILLED,
  CREATE_A_SAVED_WORKOUT_REJECTED,
  CREATE_PARENT_CHILD_CALENDAR_FULFILLED,
  CREATE_PARENT_CHILD_CALENDAR_REJECTED,
  CLEAR_MOST_RECENTLY_ADDED_CALENDAR_ITEM_TRACKER,
  SET_IS_BEFORE_RECURRING_SECTION_EXPANDED,
  SET_IS_AFTER_RECURRING_SECTION_EXPANDED,
  SET_IS_ATHLETE_ADDED_ITEMS_SECTION_EXPANDED,
  SET_PLACEHOLDER_INFO,
  SET_DRAG_IS_IN_PROGRESS,
  SET_DROPPABLE_CONTAINER_CURRENTLY_HOVERED_BY_DRAGGED_ITEM,
  SET_DRAG_CLONE_GEOMETRY,
  FETCH_WORKOUT_TEMPLATE_DATA_START,
  FETCH_WORKOUT_TEMPLATE_DATA_FULFILLED,
  FETCH_WORKOUT_TEMPLATE_DATA_REJECTED,
  SET_CALENDAR_ITEMS_NAMESPACED,
  UPDATE_CALENDAR_ITEMS_ORDER_START_NAMESPACED,
  UPDATE_CALENDAR_ITEMS_ORDER_FULFILLED_NAMESPACED,
  UPDATE_CALENDAR_ITEMS_ORDER_REJECTED_NAMESPACED,
  ADD_PRESAVED_ITEM_TO_CALENDAR_ITEMS_ARRAY_NAMESPACED,
  SET_COMBINE_WITH_INFO_NAMESPACED,
  SET_PROGRAM_TYPE,
  SET_CREATE_MODAL_PROGRAM_TYPE,
  SET_PRESAVE_TABLE_LOCAL_STATE,
  REMOVE_PRESAVE_TABLE_LOCAL_STATE,
  CLEAR_PRESAVE_TABLE_LOCAL_STATE,
  SET_SELECTED_START_DAY_OF_WEEK,
  SET_SELECTED_NUMBER_OF_DAYS_TO_SHOW_IN_WEEK,
  SET_SELECTED_DAYS_OF_WEEK_TO_SHOW_IN_CURRENT_WEEK,
  SET_GROUP_BY_FILTER,
  SET_VIEW_TYPE,
  SET_CURRENTLY_DISPLAYED_WEEKDAYS,
  SET_CURRENTLY_DISPLAYED_PROGRAM_DAYS,
  SET_CALENDAR_DAY_TOTALS,
  SET_SELECTED_WEEK_VIEW_DAY_TOGGLE,
  FETCH_FUTURE_OCCURRENCES_COUNT_START,
  FETCH_FUTURE_OCCURRENCES_COUNT_FULFILLED,
  FETCH_FUTURE_OCCURRENCES_COUNT_REJECTED,
  SET_ORDERING_INFO_MODAL_OPEN,
  FETCH_PREVIEW_WORKOUTS_START,
  FETCH_PREVIEW_WORKOUTS_FULFILLED,
  FETCH_PREVIEW_WORKOUTS_REJECTED,
  SET_PREVIEW_ACTIVE_EXERCISE_INDEX,
  SET_PREVIEW_DATE,
  SET_PREVIEW_DAY_NUMBER,
  UNDO_CALENDAR_ACTION_START,
  UNDO_CALENDAR_ACTION_FULFILLED,
  UNDO_CALENDAR_ACTION_REJECTED,
  SET_CALENDAR_ACTION_EXPIRED,
  CLEAR_WORKOUT_ITEMS_FULFILLED,
  LOAD_SAVED_PROGRAM_FULFILLED,
  COPY_WORKOUT_ITEMS_FULFILLED,
} from './actionTypes';
import {
  DELETE_CALENDARS_FULFILLED,
  ARCHIVE_CALENDARS_FULFILLED,
} from '../../calendars/ducks/actionTypes';

/**
 * Undo target/history fields that belong to one calendar/athlete/program
 * selection - zeroed when the coach switches to a different selection so the
 * header Undo button and Action History sidebar don't keep targeting the
 * previous one.
 */
const UNDO_STATE_RESET = {
  calendarAction: null,
  calendarActionSetAt: null,
  calendarActionBatchId: null,
  calendarActionHistory: [],
  batchIdByCalendarActionId: {},
  selectedHistoryEntryId: null,
  gestureParticipantCountByBatchId: {},
};

/**
 * Mutation responses are moving from a bare `calendarActionId: number` to a full
 * `calendarAction: CalendarActionHistoryItem` object (which adds `expiresAt`, so the
 * undo button can check eligibility client-side instead of always hitting the undo
 * endpoint and relying on the server to reject stale ones). Endpoints migrate one at a
 * time, so this normalizes either shape into a single `calendarAction` field - a
 * legacy `calendarActionId`-only response becomes a minimal `{ id }` object with no
 * `expiresAt`, which the undo button treats as "no eligibility info, allow it" (the
 * pre-migration behavior) until that endpoint sends the richer shape.
 */
const buildCalendarActionField = (payload) => {
  if (payload?.calendarAction !== undefined) {
    return { calendarAction: payload.calendarAction };
  }
  if (payload?.calendarActionId !== undefined) {
    // null means "nothing left to undo" (e.g. the undo endpoint's response) -
    // keep it null rather than wrapping it into a truthy { id: null } object.
    return { calendarAction: payload.calendarActionId === null ? null : { id: payload.calendarActionId } };
  }
  return {};
};

// Multi-row gestures (drag-to-combine in day/week view, bulk supersetting)
// fire N independent requests for what the coach experiences as ONE action,
// each with its own row/id. Whichever request's FULFILLED lands last would
// otherwise blindly overwrite calendarAction - the single fallback target the
// header Undo button and Cmd/Ctrl+Z use when no explicit target is given.
// Since the backend's undo cascade only sweeps FORWARD (id > targetActionId),
// that fallback needs to end up holding the LOWEST id of the group, or a
// quick-undo silently reverts only one row of the gesture instead of all of it.
//
// "Same gesture" means matching batchId (plus same day), with no time limit.
// A genuine bulk gesture (drag-combine, bulk superset) already shares ONE
// batchId across all its requests (see getCombineSharedBatchId.js and
// persistSupersetGrouping's sharedBulkBatchId), and so does an auto-saved add
// plus the edits the coach makes to that item afterward (see
// saveCalendarExercise) - which can land well apart in time. The backend's
// action history likewise represents a batch by its lowest-id non-reorder
// row, so holding that id here keeps quick-undo pointed at the same entry the
// history panel shows. Two separate edits to different items never match:
// each item gets its own batch (see SET_ACTIVE_EXERCISE_ID), so editing A then
// quickly editing B still leaves calendarAction on B.

const buildCalendarActionSetPatch = (
  payload,
  currentCalendarAction,
  currentCalendarActionBatchId,
) => {
  const field = buildCalendarActionField(payload);
  if (field.calendarAction === undefined) return {};

  const incoming = field.calendarAction;
  // Every action creator that reaches this function already computes its own
  // batchId locally before sending the request (see the request body each
  // one builds) - this just reads that same value back out of this request's
  // own FULFILLED payload. The backend never needs to echo it.
  const incomingBatchId = payload?.batchId ?? null;
  const now = Date.now();
  const isSameGesture = incoming?.id != null
    && currentCalendarAction?.id != null
    && incoming.targetStartDate === currentCalendarAction.targetStartDate
    && incomingBatchId != null
    && incomingBatchId === currentCalendarActionBatchId;
  const nextCalendarAction = isSameGesture && incoming.id > currentCalendarAction.id
    ? currentCalendarAction
    : incoming;

  return {
    calendarAction: { $set: nextCalendarAction },
    calendarActionSetAt: { $set: now },
    // Tracked alongside calendarAction so the NEXT FULFILLED to land can
    // compare against it - distinct from currentBatchId (state.currentBatchId
    // is "what the next OUTGOING request should use"; this is "what batchId
    // produced the CURRENTLY-tracked calendarAction"). incomingBatchId is
    // null for any not-yet-migrated/no-batchId action (e.g. an undo itself),
    // which is the correct conservative "never merge against this" value.
    calendarActionBatchId: { $set: isSameGesture ? currentCalendarActionBatchId : incomingBatchId },
    // Also record this specific history row's own batchId in the live map -
    // this is what lets HistorySideBarContent's display grouping later prove
    // "these two entries were really one superset gesture" instead of
    // guessing from timing. Every call site here already carries both an id
    // and a batchId once an action creator has been migrated to send one.
    ...(incoming?.id != null && incomingBatchId != null ? {
      batchIdByCalendarActionId: { $merge: { [incoming.id]: incomingBatchId } },
    } : {}),
  };
};

/** An item's assignedId changes on the FULFILLED of a pre-save auto-save or a
 * child-calendar swap. Keep the focus-tracking ids pointed at it across that
 * swap, without touching currentBatchId (still the same edit session) -
 * otherwise the next click in the same item looks like a switch to a different
 * one and wrongly mints a fresh batch. lastActiveExerciseId matters when the
 * coach clicked off the row while the request was in flight: it's what lets
 * clicking back in rejoin the batch (see SET_ACTIVE_EXERCISE_ID). */
const buildActiveExerciseIdRemapPatch = (state, fromId, toId) => ({
  ...(state.activeExerciseId === fromId ? { activeExerciseId: { $set: toId } } : {}),
  ...(state.lastActiveExerciseId === fromId ? { lastActiveExerciseId: { $set: toId } } : {}),
});

/** State patch for switching Build to `calendar` (or `{}` to clear the
 * selection): resets everything that belonged to the previous selection. */
const buildSelectCalendarPatch = (calendar) => ({
  selectedReduxCalendar: calendar,
  selectedReduxAthlete: {},
  activeModal: '',
  shouldUpdateRecurring: true,
  calendarItems: {},
  calendarItemsDateRange: {
    earliest: null,
    latest: null,
  },
  recurringItemsDateRange: {
    earliest: null,
    latest: null,
  },
  focusTarget: null,
  mostRecentlyAddedCalendarItem: null,
});

const initialState = {
  programType: 'calendar',
  /** The coach's Default Entry View preference (Settings > General), read from
   * localStorage once here so the right view is in place before the first
   * render. Defaults to day view. */
  viewType: resolveEntryViewType(),
  createModalProgramType: 'calendar',
  selectedWeekViewDayToggle: 'Everyday',
  placeholderInfo: null,
  dragCloneGeometry: null,
  dragIsInProgress: false,
  droppableIds: [],
  animatedSidebarContainerWidth: null,
  droppableContainerCurrentlyHoveredByDraggedItem: null,
  sideBarExerciseSearchTerm: null,
  exercisePickerSearchTerm: null,
  isCalendarOptionsDropdownMenuOpen: false,
  isStaticAddColumnDropdownMenuOpen: false,
  isBeforeRecurringSectionExpanded: false,
  isAfterRecurringSectionExpanded: false,
  isAthleteAddedItemsSectionExpanded: false,
  isSupersetPickerOpen: false,
  selectedDate: moment(),
  selectedProgramDayNumber: 0,
  itemIndexForSelectedProgramDayNumber: 0,
  selectedMonth: moment().month() + 1,
  firstMonthInPicker: moment().startOf('month').toDate(),
  // Sunday (YYYY-MM-DD) of the top week of the month view's rolling 10-week
  // window. Defaults to 2 weeks before this week so today's week is the focus.
  monthViewWindowStart: getMonthViewWindowStart(moment()),
  // Bumped on focus-centering events (entry / Today / picker day-select) to
  // tell MonthView to scroll the focus week to the top of the viewport.
  monthViewFocusToken: 0,
  // Bumped to force a non-destructive refetch of the month window (e.g. after a
  // paste) without wiping calendarItems.
  monthViewRefetchToken: 0,
  // Prev/next-month nav intent from the header arrows: { direction, nonce }.
  // MonthView resolves it against the month currently scrolled into view.
  monthViewNavRequest: null,
  calendar: [],
  workoutCalendar: [],
  combineWithInfo: null,
  isPrimaryAnimatedSideBarOpen: false,
  primarySideBarDataTag: null,
  secondarySideBarDataTag: null,
  // Phone-icon sidebar workout preview (athlete view-only)
  previewWorkoutItems: [],
  isPreviewWorkoutsLoading: false,
  previewWorkoutsError: null,
  // Latest preview fetch id; FULFILLED/REJECTED for any older id are dropped so a slow response
  // can't overwrite the preview after the user has moved on (last-requested wins, not last-resolved).
  latestPreviewRequestId: 0,
  previewActiveExerciseIndex: null,
  previewDate: null,
  previewDayNumber: null,
  // Free-form program preview: the athlete's resolved day-based program id (and assignment
  // instance), surfaced from getPreviewWorkoutItemsFreeForm so the "View In Workout Entry"
  // button can deep-link to /workouts. The template id (selectedReduxNonDateBasedProgram.id)
  // is NOT usable here. Null in date-based mode / when the athlete has no access.
  previewDayBasedProgramId: null,
  previewDayBasedInstanceId: null,
  activeModal: '',
  modalData: null,
  activeSecondLayerModal: '',
  secondLayerModalData: null,
  selectedReduxCalendar: {},
  selectedReduxAthlete: {},
  selectedReduxNonDateBasedProgram: {},
  isCloneDragging: false,
  onBeforeCapture: false,
  calendarContainerScrollPosition: null,
  combineWithId: null,
  calendarPanelContainerWidth: 0,
  headerHeight: null,
  allExercises: [],
  recentlyFetchedExercise: null,
  newlyCreatedExercise: null,
  calendarItems: {},
  calendarItemsDateRange: {
    earliest: null,
    latest: null,
  },
  nonDateBasedProgramItems: [],
  mostRecentlyAddedCalendarItem: null,
  /** The most recent pre-save → saved assignedId migration, as { from, to }.
   * A save replaces the row in place under a brand-new id, so anything holding
   * the old one (the month edit popover) would otherwise conclude the item was
   * deleted. Never cleared: a consumer only reacts when `from` matches the id
   * it currently holds, and reacting rewrites that id to `to`, so a given swap
   * cannot apply twice and a stale value is inert. */
  lastPreSaveIdSwap: null,
  calendarPickerItems: [],
  selectedItems: {},
  /** Month view only: day (YYYY-MM-DD) the current multi-selection lives in. */
  monthSelectionActiveDate: null,
  copiedSelectedItems: null,
  expandedItems: {},
  weekViewExpandedDay: null,
  focusTarget: null,
  activeExerciseId: null,
  addInfoContent: {},
  iframelyError: null,
  uploadedMedia: null,
  documents: [],
  folderDocuments: [],
  fetchedDocument: null,
  addAsset: null,
  parentCalendars: [],
  calendarSelectAthletes: [],
  clickedUpgradeNow: false,
  newPreSaveItemFromCreateExerciseForm: null,
  tagsForAccount: [],
  tagsForAllPrograms: [],
  newlyCreatedTag: null,
  calendarContainerScrollPositionTop: 0,
  // preSaveAddInfo: {},
  preSaveAddInfo: [],
  preSaveDescription: [],
  questionsForAccount: [],
  newlyCreatedQuestion: null,
  questionCount: [{
    index: 0, id: `${generateUniqueId()}-null`, isNullValue: true, isVisible: true,
  }],
  deleteStack: [],
  beforeRecurringWorkouts: {},
  afterRecurringWorkouts: {},
  recurringItemsDateRange: {
    earliest: null,
    latest: null,
  },
  shouldUpdateRecurring: true,
  shouldFetchRecurring: null,
  isDragging: false,
  dragSource: null,
  draggedItem: null,
  templates: [],
  calendarItemContainers: {
    programmedCalendarItems: [],
    liftCalendarItems: [],
    warmUpCalendarItems: [],
    SAQCCalendarItems: [],
    circuitCalendarItems: [],
    noteCalendarItems: [],
    questionnaireCalendarItems: [],
    coolDownCalendarItems: [],
    healthCalendarItems: [],
    progressionCalendarItems: [],
    tagCalendarItems: [],
    accessoryCalendarItems: [],
  },
  savedWorkouts: [],
  selectedSavedWorkout: null,
  isLoadingSavedWorkout: false,
  savedWorkoutError: null,
  lastUpdateTime: null,
  lastEditedDate: null,
  calendarAction: null,
  calendarActionSetAt: null,
  calendarActionBatchId: null,
  // A live, session-observed map of history-row id -> the batchId that request
  // used - built from the same FULFILLED payloads buildCalendarActionSetPatch
  // already reads batchId off of. Lets HistorySideBarContent's own display
  // grouping tell a genuine superset (shared batchId) apart from two separate
  // edits that just happen to land close together, without needing the
  // backend to echo batchId in the /action-history response.
  batchIdByCalendarActionId: {},
  // The history sidebar's selected boundary card - lives here (not component
  // state) so UNDO_CALENDAR_ACTION_FULFILLED can clear it directly and
  // unconditionally the instant ANY undo succeeds, regardless of source
  // (header button, Cmd/Ctrl+Z, or the sidebar's own button) and with no
  // dependency on a subsequent history refetch landing first.
  selectedHistoryEntryId: null,
  // Participant count for a genuine multi-item gesture's batchId, recorded
  // client-side at the moment the gesture is initiated (drag-combine,
  // SuperSetPickerPopup's multi-select, persistSupersetGrouping's
  // bulk-select) - NOT inferred from batchIdByCalendarActionId's id count,
  // which can also grow for repeated edits within one ordinary single-item
  // session (the swap endpoint has no dedup) and would wrongly look like a
  // multi-item gesture. Only ever keyed by gesture batchIds, which are
  // freshly-minted UUIDs never reused for a single-item edit session's
  // currentBatchId - that's what keeps this guarded to real supersets only.
  gestureParticipantCountByBatchId: {},
  isUndoingCalendarAction: false,
  currentBatchId: null,
  // The last non-null active item, remembered across a deactivation so that
  // clicking out of an item (activeExerciseId -> null) and straight back into
  // the SAME item is recognized as one continuous edit session and keeps its
  // currentBatchId, rather than minting a fresh one. See SET_ACTIVE_EXERCISE_ID.
  lastActiveExerciseId: null,
  calendarActionHistory: [],
  isFetchingCalendarActionHistory: false,
  calendarActionHistoryError: null,
  sharedWorkoutInfo: null,
  superSetPicker: null,
  workoutTemplateData: {},
  isLoadingWorkoutTemplateData: false,
  workoutTemplateDataError: null,
  preSaveTableLocalState: {},
  currentlyDisplayedWeekdays: [],
  currentlyDisplayedProgramDays: [],
  selectedStartDayOfWeek: 'Sunday',
  selectedNumberOfDaysToShowInWeek: 7,
  selectedDaysOfWeekToShowInCurrentWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Empty Days', 'Weekends'],
  groupByFilter: 'Week',
  newlyCreatedCalendar: null,
  futureOccurrencesCount: null,
  swapDropdownToggleEnabled: false,
  undoDeleteMetadata: {},
  isOrderingInfoModalOpen: false,
};

/** Compute the next expandedItems map after a day's exercises have been
 * replaced. Two cases auto-expand:
 *   1. A session_break that's brand new to this day AND we've never seen
 *      its key. The previousIds guard prevents resurrecting expansion for
 *      a SB that was already on the day but had its key dropped by some
 *      other path (e.g. handleToggleExpand rebuilding the map) — that
 *      should preserve user intent, not silently re-expand.
 *   2. An item now sitting under a session_break that was already on this
 *      day and didn't have that item under it before — force-expand the
 *      break so the user can see what just dropped into it. Skipped when
 *      the session_break itself is new to the day, because its chunk came
 *      with it and isn't a "new drop under" event. */
const withSessionBreaksExpanded = (expandedItems, newExercises, previousExercises) => {
  if (!newExercises?.length) return expandedItems;

  const previousIds = new Set();
  const previousUnderMap = {};
  let prevSb = null;
  (previousExercises || []).forEach((ex) => {
    if (!ex) return;
    previousIds.add(ex.assignedId);
    if (ex.type === 'session_break') {
      prevSb = ex.assignedId;
      if (!previousUnderMap[prevSb]) previousUnderMap[prevSb] = new Set();
    } else if (prevSb != null) {
      previousUnderMap[prevSb].add(ex.assignedId);
    }
  });

  let next = expandedItems;
  let currentSb = null;
  newExercises.forEach((ex) => {
    if (!ex) return;
    if (ex.type === 'session_break') {
      currentSb = ex.assignedId;
      if (
        !previousIds.has(ex.assignedId)
        && !Object.prototype.hasOwnProperty.call(next, ex.assignedId)
      ) {
        if (next === expandedItems) next = { ...expandedItems };
        next[ex.assignedId] = true;
      }
    } else if (currentSb != null && previousIds.has(currentSb)) {
      const prevUnder = previousUnderMap[currentSb];
      if (!prevUnder || !prevUnder.has(ex.assignedId)) {
        if (next === expandedItems) next = { ...expandedItems };
        next[currentSb] = true;
      }
    }
  });
  return next;
};

// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CAL_WORKOUT_CALENDAR_START: {
      return {
        ...state,
        workoutCalendar: [],
      };
    }
    case FETCH_CAL_WORKOUT_CALENDAR_FULFILLED: {
      return {
        ...state,
        workoutCalendar: action.payload,
      };
    }
    case FETCH_PARENT_CALENDARS_FULFILLED: {
      return {
        ...state,
        parentCalendars: action.payload.data,
      };
    }
    case FETCH_QUESTIONS_FOR_ACCOUNT_CALENDAR_FULFILLED: {
      return {
        ...state,
        questionsForAccount: action.payload,
      };
    }
    case CREATE_QUESTION_FOR_ACCOUNT_FULTILLED: {
      return {
        ...state,
        newlyCreatedQuestion: action.payload,
      };
    }
    case CLEAR_NEWLY_CREATED_QUESTION: {
      return {
        ...state,
        newlyCreatedQuestion: null,
      };
    }
    case FETCH_PARENT_CALENDARS_REJECTED: {
      return {
        ...state,
        calendarsError: action.payload,
      };
    }
    case FETCH_CAL_WORKOUT_CALENDAR_REJECTED: {
      return {
        ...state,
        workoutCalendarError: action.payload,
      };
    }
    case SET_CLICKED_UPGRADE_NOW: {
      return {
        ...state,
        clickedUpgradeNow: action.payload,
      };
    }
    case SET_PROGRAM_TYPE: {
      /** Crossing between scheduled workouts and the Program Library lands on
       * the coach's default view for the new mode (read into meta by
       * setProgramType). Staying within a mode - program A to B, calendar A
       * to B - keeps whatever view they're in. */
      const isModeSwitch = action.payload !== state.programType;
      let nextViewType = isModeSwitch && action.meta?.entryViewType
        ? action.meta.entryViewType
        : state.viewType;
      /** Month view's grid is date-based and doesn't render free-form-program
       * items (keyed by dayNumber in nonDateBasedProgramItems), so the
       * Program Library never lands on it, whatever arrives. */
      if (action.payload === 'free-form-program' && nextViewType === 'monthView') {
        nextViewType = 'dayView';
      }
      const viewChanged = nextViewType !== state.viewType;
      return {
        ...state,
        programType: action.payload,
        weekViewExpandedDay: null,
        /** The view changes in this same pass, not via setViewType, so effects
         * keyed on [programType, viewType] run once. That means repeating
         * setViewType's clears here: entering a program clears these through
         * the program selection, but returning to a calendar doesn't. */
        ...(viewChanged && {
          viewType: nextViewType,
          selectedItems: {},
          expandedItems: {},
          monthSelectionActiveDate: null,
        }),
        /** And its month-entry snap, initMonthViewWindow(new Date()) - or a
         * dated deeplink's date, which would otherwise be lost here. */
        ...(viewChanged && nextViewType === 'monthView' && {
          monthViewWindowStart: getMonthViewWindowStart(moment(action.meta?.monthFocusDate)),
          monthViewFocusToken: (state.monthViewFocusToken || 0) + 1,
        }),
      };
    }
    case SET_CREATE_MODAL_PROGRAM_TYPE: {
      return {
        ...state,
        createModalProgramType: action.payload,
      };
    }
    case SET_ORDERING_INFO_MODAL_OPEN: {
      return {
        ...state,
        isOrderingInfoModalOpen: action.payload,
      };
    }
    case SET_IS_BEFORE_RECURRING_SECTION_EXPANDED: {
      return {
        ...state,
        isBeforeRecurringSectionExpanded: action.payload,
      };
    }
    case SET_IS_AFTER_RECURRING_SECTION_EXPANDED: {
      return {
        ...state,
        isAfterRecurringSectionExpanded: action.payload,
      };
    }
    case SET_IS_ATHLETE_ADDED_ITEMS_SECTION_EXPANDED: {
      return {
        ...state,
        isAthleteAddedItemsSectionExpanded: action.payload,
      };
    }
    case CLEAR_MOST_RECENTLY_ADDED_CALENDAR_ITEM_TRACKER: {
      return {
        ...state,
        mostRecentlyAddedCalendarItem: null,
      };
    }
    case SET_IS_CALENDAR_OPTIONS_DROPDOWN_MENU_OPEN: {
      return {
        ...state,
        isCalendarOptionsDropdownMenuOpen: action.payload,
      };
    }
    case SET_IS_STATIC_ADD_COLUMN_DROPDOWN_MENU_OPEN: {
      return {
        ...state,
        isStaticAddColumnDropdownMenuOpen: action.payload,
      };
    }
    case SET_IS_SUPERSET_PICKER_OPEN: {
      return {
        ...state,
        isSupersetPickerOpen: action.payload,
      };
    }
    case SET_SUPERSET_PICKER_OPEN_BY_ID: {
      return {
        ...state,
        isSupersetPickerOpen: {
          ...state.isSupersetPickerOpen,
          [action.payload]: true,
        },
      };
    }
    case REMOVE_SUPERSET_PICKER_OPEN_BY_ID: {
      const { [action.payload]: _, ...rest } = state.isSupersetPickerOpen;
      return {
        ...state,
        isSupersetPickerOpen: rest,
      };
    }
    case SET_COMBINE_WITH_INFO: {
      return {
        ...state,
        combineWithInfo: action.payload,
      };
    }
    case SET_SUPERSET_PICKER: {
      return {
        ...state,
        superSetPicker: action.payload,
      };
    }
    case SET_CALENDAR_CONTENT_SCROLL_CONTAINER_TOP_POSITION: {
      return {
        ...state,
        calendarContainerScrollPositionTop: action.payload,
      };
    }
    case SET_IS_PRIMARY_ANIMATED_SIDE_BAR_OPEN: {
      return {
        ...state,
        isPrimaryAnimatedSideBarOpen: action.payload,
      };
    }
    case SET_SWAP_DROPDOWN_TOGGLE_ENABLED: {
      return {
        ...state,
        swapDropdownToggleEnabled: action.payload,
      };
    }
    case SET_PRIMARY_SIDE_BAR_DATA_TAG: {
      return {
        ...state,
        primarySideBarDataTag: action.payload,
      };
    }
    case SET_SECONDARY_SIDE_BAR_DATA_TAG: {
      return {
        ...state,
        secondarySideBarDataTag: action.payload,
      };
    }
    case SET_NEW_PRESAVE_ITEM_FROM_CREATE_EXERCISE_FORM: {
      return {
        ...state,
        newPreSaveItemFromCreateExerciseForm: action.payload,
      };
    }
    case SET_QUESTION_COUNT: {
      return {
        ...state,
        questionCount: action.payload,
      };
    }
    case SET_ACTIVE_MODAL: {
      return {
        ...state,
        activeModal: action.payload.modalType,
        modalData: action.payload.modalData,
      };
    }
    case SET_ACTIVE_SECOND_LAYER_MODAL: {
      return {
        ...state,
        activeSecondLayerModal: action.payload.modalType,
        secondLayerModalData: action.payload.modalData,
      };
    }
    case SET_SELECTED_REDUX_CALENDAR: {
      const nextState = {
        ...state,
        ...buildSelectCalendarPatch(action.payload),
      };
      // Copy, clear and load-program reload items by re-selecting the SAME
      // calendar - that must keep the undo target they just set, or the
      // header Undo button vanishes right after the action. Only a genuine
      // switch drops the previous calendar's undo target/history.
      const isSwitch = getCalendarSelectionKey(nextState) !== getCalendarSelectionKey(state);
      return {
        ...nextState,
        ...(isSwitch ? UNDO_STATE_RESET : {}),
      };
    }
    /** Deleted/archived in Manage Calendars: if Build's selection (or a child
     * selection's parent) was one of them, drop it so returning to Build lands
     * on the entry point instead of the removed calendar. */
    case DELETE_CALENDARS_FULFILLED:
    case ARCHIVE_CALENDARS_FULFILLED: {
      const removedIds = action.payload?.successful || [];
      const { selectedReduxCalendar } = state;
      const isSelectionRemoved = removedIds.includes(selectedReduxCalendar?.id)
        || removedIds.includes(selectedReduxCalendar?.parentCalendarInfo?.id);
      if (!isSelectionRemoved) return state;
      return {
        ...state,
        ...buildSelectCalendarPatch({}),
        ...UNDO_STATE_RESET,
      };
    }
    case SET_SELECTED_REDUX_ATHLETE: {
      const nextState = {
        ...state,
        selectedReduxAthlete: action.payload,
        selectedReduxCalendar: {},
      };
      // See SET_SELECTED_REDUX_CALENDAR above.
      const isSwitch = getCalendarSelectionKey(nextState) !== getCalendarSelectionKey(state);
      return {
        ...nextState,
        activeModal: '',
        shouldUpdateRecurring: true,
        calendarItems: {},
        calendarItemsDateRange: {
          earliest: null,
          latest: null,
        },
        recurringItemsDateRange: {
          earliest: null,
          latest: null,
        },
        focusTarget: null,
        mostRecentlyAddedCalendarItem: null,
        ...(isSwitch ? UNDO_STATE_RESET : {}),
      };
    }
    case SET_SELECTED_REDUX_NON_DATE_BASED_PROGRAM: {
      return {
        ...state,
        /** spreading this and making new reference so it always trigger a change */
        // selectedReduxNonDateBasedProgram: { ...action.payload },
        selectedReduxNonDateBasedProgram: action.payload,
        selectedReduxAthlete: {},
        selectedReduxCalendar: {},
        activeModal: '',
        shouldUpdateRecurring: true,
        selectedItems: {},
        expandedItems: {},
        weekViewExpandedDay: null,
        focusTarget: null,
        mostRecentlyAddedCalendarItem: null,
        // The previous selection's undo target/history doesn't belong here.
        ...UNDO_STATE_RESET,
      };
    }
    case SET_SELECTED_SAVED_WORKOUT: {
      return {
        ...state,
        selectedSavedWorkout: action.payload,
      };
    }
    case SET_SELECTED_DATE: {
      return {
        ...state,
        selectedDate: action.payload,
        shouldUpdateRecurring: true,
        weekViewExpandedDay: null,
        focusTarget: null,
        mostRecentlyAddedCalendarItem: null,
      };
    }
    case SET_CURRENTLY_DISPLAYED_WEEKDAYS: {
      return {
        ...state,
        currentlyDisplayedWeekdays: action.payload,
      };
    }
    case SET_CURRENTLY_DISPLAYED_PROGRAM_DAYS: {
      return {
        ...state,
        currentlyDisplayedProgramDays: action.payload,
      };
    }
    case SET_CALENDAR_DAY_TOTALS: {
      /** Surgically refresh the day-level totals from a silent refetch. Volume is backend-computed
       * and never returned per-exercise on save; sets/reps come from the same response because the
       * reducer can't always recompute them either (a cross-date move empties the source day's
       * exercises without touching its aggregates). Leaves exercises and any preSave rows untouched,
       * and only updates days already present in calendarItems. A field missing from the payload
       * keeps its current value rather than blanking to 0. */
      const totalsByDate = action.payload;
      const calendarItems = { ...state.calendarItems };
      Object.keys(totalsByDate).forEach((date) => {
        const day = calendarItems[date];
        if (day) {
          const totals = totalsByDate[date] || {};
          calendarItems[date] = {
            ...day,
            totalVolumeLoad: totals.totalVolumeLoad ?? day.totalVolumeLoad,
            setCount: totals.setCount ?? day.setCount,
            repCount: totals.repCount ?? day.repCount,
          };
        }
      });
      return {
        ...state,
        calendarItems,
      };
    }
    case SET_SELECTED_WEEK_VIEW_DAY_TOGGLE: {
      return {
        ...state,
        selectedWeekViewDayToggle: action.payload,
      };
    }
    case SET_SELECTED_START_DAY_OF_WEEK: {
      return {
        ...state,
        selectedStartDayOfWeek: action.payload,
      };
    }
    case SET_SELECTED_NUMBER_OF_DAYS_TO_SHOW_IN_WEEK: {
      return {
        ...state,
        selectedNumberOfDaysToShowInWeek: action.payload,
      };
    }
    case SET_SELECTED_DAYS_OF_WEEK_TO_SHOW_IN_CURRENT_WEEK: {
      return {
        ...state,
        selectedDaysOfWeekToShowInCurrentWeek: action.payload,
      };
    }
    case SET_GROUP_BY_FILTER: {
      return {
        ...state,
        groupByFilter: action.payload,
      };
    }
    case SET_SELECTED_PROGRAM_DAY_NUMBER: {
      return {
        ...state,
        selectedProgramDayNumber: action.payload,
      };
    }
    case SET_SELECTED_MONTH: {
      return {
        ...state,
        selectedMonth: action.payload,
      };
    }
    case SET_FIRST_MONTH_IN_PICKER: {
      return {
        ...state,
        firstMonthInPicker: action.payload,
      };
    }
    case SET_MONTH_VIEW_WINDOW_START: {
      return {
        ...state,
        monthViewWindowStart: action.payload,
      };
    }
    case CENTER_MONTH_VIEW_ON_FOCUS: {
      return {
        ...state,
        monthViewFocusToken: (state.monthViewFocusToken || 0) + 1,
      };
    }
    /** Bump a token so month view refetches its current window without wiping
     * calendarItems (avoids the flicker where every day blanks out then
     * reappears). Used after a paste, since the merge replaces days in place. */
    case REFETCH_MONTH_VIEW_ITEMS: {
      return {
        ...state,
        monthViewRefetchToken: (state.monthViewRefetchToken || 0) + 1,
      };
    }
    case REQUEST_MONTH_VIEW_MONTH_NAV: {
      return {
        ...state,
        monthViewNavRequest: {
          direction: action.payload,
          nonce: (state.monthViewNavRequest?.nonce || 0) + 1,
        },
      };
    }

    case SET_ACTIVE_EXERCISE_ID: {
      // Deactivating (payload === null): leave currentBatchId untouched so a
      // trailing debounced save for the item that just lost focus still lands
      // in the batch that was current while the edit was made. Remember the
      // outgoing item in lastActiveExerciseId so that clicking straight back
      // into it is recognized as the same edit session (see below). Guard
      // against null -> null (repeated outside-clicks) wiping that memory.
      if (!action.payload) {
        return {
          ...state,
          activeExerciseId: null,
          lastActiveExerciseId: state.activeExerciseId !== null
            ? state.activeExerciseId
            : state.lastActiveExerciseId,
        };
      }

      // Re-click of the already-active item: no batch change.
      if (action.payload === state.activeExerciseId) {
        return { ...state, activeExerciseId: action.payload };
      }

      // Returning from a click-out (activeExerciseId is null) to the exact item
      // that was active just before it: keep the preserved currentBatchId so
      // the whole click-out-and-back edit session shares one batch. This is
      // deliberately narrow - only a null -> sameItem return reuses. Any other
      // activation (a genuinely different or new item, or a return after
      // visiting another item) mints a fresh batch, which is what keeps two
      // different assignedIds from ever sharing one ASSIGNMENT_UPDATE batchId
      // (the backend snapshot-loss case).
      const isReturnToSameItemAfterDeactivate = state.activeExerciseId === null
        && action.payload === state.lastActiveExerciseId;

      return {
        ...state,
        activeExerciseId: action.payload,
        lastActiveExerciseId: null,
        ...(isReturnToSameItemAfterDeactivate ? {} : { currentBatchId: uuidv4() }),
      };
    }
    /** Expanding/collapsing an item (or closing month view's edit popover)
     * starts a new batch for the same active item - see startNewEditBatch.
     * Programmatic SET_EXPANDED_ITEM/REMOVE_EXPANDED_ITEM deliberately don't
     * mint: an add expands the saved item, and a lift's add must keep sharing
     * its batch with the edits that follow. */
    case START_NEW_EDIT_BATCH: {
      return {
        ...state,
        currentBatchId: uuidv4(),
      };
    }
    case SET_SELECTED_ITEMS: {
      return {
        ...state,
        selectedItems: action.payload,
      };
    }
    case SET_SELECTED_ITEM: {
      return {
        ...state,
        selectedItems: {
          ...state.selectedItems,
          [action.payload.assignedId]: action.payload,
        },
      };
    }

    case REMOVE_SELECTED_ITEM: {
      const { [action.payload.assignedId]: _, ...rest } = state.selectedItems;
      return {
        ...state,
        selectedItems: rest,
      };
    }

    case SET_MONTH_SELECTION_ACTIVE_DATE: {
      return {
        ...state,
        monthSelectionActiveDate: action.payload,
      };
    }
    case SET_COPIED_SELECTED_ITEMS: {
      return {
        ...state,
        copiedSelectedItems: action.payload,
      };
    }
    case SET_EXPANDED_ITEMS: {
      return {
        ...state,
        expandedItems: action.payload,
      };
    }

    case SET_EXPANDED_ITEM: {
      return {
        ...state,
        expandedItems: {
          ...state.expandedItems,
          [action.payload.assignedId]: action.payload,
        },
      };
    }

    case REMOVE_EXPANDED_ITEM: {
      const { [action.payload.assignedId]: _, ...rest } = state.expandedItems;
      return {
        ...state,
        expandedItems: rest,
      };
    }

    case SET_SESSION_BREAK_COLLAPSED: {
      return {
        ...state,
        expandedItems: {
          ...state.expandedItems,
          [action.payload.assignedId]: false,
        },
      };
    }

    case SET_WEEK_VIEW_EXPANDED_DAY: {
      return {
        ...state,
        weekViewExpandedDay: action.payload,
        selectedItems: {},
      };
    }
    // This case statement handles the action to focus on the next preSave item in the calendar.
    // It extracts the current index and selected date from the action payload, formats the date,
    // and retrieves the list of exercises for that date. It then searches for the next item
    // marked with preSave starting from the current index. If it encounters a collapsed session
    // break, it skips over all items until the next session break. If found, it updates the state to
    // expand the next preSave item and sets the focus target to this item, including its index,
    // assigned ID, and a timestamp. If no such item is found, the state remains unchanged.
    case FOCUS_NEXT_PRESAVE_ITEM: {
      const { currentIndex, selectedDate } = action.payload;
      const formattedDate = moment(selectedDate).format('YYYY-MM-DD');
      const calendarItems = state.calendarItems[formattedDate]?.exercises || [];

      // Find next preSave item starting from currentIndex + 1
      let nextPreSaveIndex = -1;
      for (let i = currentIndex + 1; i < calendarItems.length; i += 1) {
        const currentItem = calendarItems[i];

        // Check if this is a session break
        if (currentItem?.type === 'session_break') {
          // Check if the session break is collapsed (not in expandedItems)
          if (!state.expandedItems[currentItem.assignedId]) {
            // Skip over all items until the next session break
            let nextSessionBreakIndex = -1;
            for (let j = i + 1; j < calendarItems.length; j += 1) {
              if (calendarItems[j]?.type === 'session_break') {
                nextSessionBreakIndex = j;
                break;
              }
            }

            // If we found another session break, jump to it; otherwise we're done searching
            if (nextSessionBreakIndex !== -1) {
              i = nextSessionBreakIndex - 1; // -1 because the loop will increment
            } else {
              // No more session breaks, we're done searching
              break;
            }
          }
          // If session break is expanded, we skip this iteration but continue the loop
        } else if (currentItem?.preSave === true) {
          // Check if this item is a preSave item
          nextPreSaveIndex = i;
          break;
        }
      }

      if (nextPreSaveIndex !== -1) {
        const nextItem = calendarItems[nextPreSaveIndex];
        return {
          ...state,
          expandedItems: {
            ...state.expandedItems,
            [nextItem.assignedId]: nextItem,
          },
          focusTarget: {
            itemIndex: nextPreSaveIndex,
            assignedId: nextItem.assignedId,
            timestamp: Date.now(),
          },
        };
      }

      // No more pre-save items found, focus the first focusable field in the item that was just saved
      const currentItem = calendarItems[currentIndex];
      if (currentItem) {
        return {
          ...state,
          focusTarget: {
            itemIndex: currentIndex,
            assignedId: currentItem.assignedId,
            timestamp: Date.now(),
            focusFirstField: true, // Flag to indicate we want to focus the first field
          },
        };
      }
      return state;
    }
    case FOCUS_NEXT_PRESAVE_PROGRAM_ITEM: {
      const { currentIndex, dayNumber } = action.payload;
      const programItems = state.nonDateBasedProgramItems[dayNumber]?.exercises || [];

      // Find next preSave item starting from currentIndex + 1
      let nextPreSaveIndex = -1;
      for (let i = currentIndex + 1; i < programItems.length; i += 1) {
        const currentItem = programItems[i];

        // Check if this is a session break
        if (currentItem?.type === 'session_break') {
          // Check if the session break is collapsed (not in expandedItems)
          if (!state.expandedItems[currentItem.assignedId]) {
            // Skip over all items until the next session break
            let nextSessionBreakIndex = -1;
            for (let j = i + 1; j < programItems.length; j += 1) {
              if (programItems[j]?.type === 'session_break') {
                nextSessionBreakIndex = j;
                break;
              }
            }

            // If we found another session break, jump to it; otherwise we're done searching
            if (nextSessionBreakIndex !== -1) {
              i = nextSessionBreakIndex - 1; // -1 because the loop will increment
            } else {
              // No more session breaks, we're done searching
              break;
            }
          }
          // If session break is expanded, we skip this iteration but continue the loop
        } else if (currentItem?.preSave === true) {
          // Check if this item is a preSave item
          nextPreSaveIndex = i;
          break;
        }
      }

      if (nextPreSaveIndex !== -1) {
        const nextItem = programItems[nextPreSaveIndex];
        return {
          ...state,
          expandedItems: {
            ...state.expandedItems,
            [nextItem.assignedId]: nextItem,
          },
          focusTarget: {
            itemIndex: nextPreSaveIndex,
            assignedId: nextItem.assignedId,
            timestamp: Date.now(),
          },
        };
      }

      // No more pre-save items found, focus the first focusable field in the item that was just saved
      const currentItem = programItems[currentIndex];
      if (currentItem) {
        return {
          ...state,
          focusTarget: {
            itemIndex: currentIndex,
            assignedId: currentItem.assignedId,
            timestamp: Date.now(),
            focusFirstField: true,
          },
        };
      }
      return state;
    }
    case SET_IS_CLONE_DRAGGING: {
      return {
        ...state,
        isCloneDragging: action.payload,
      };
    }
    case SET_ON_BEFORE_CAPTURE: {
      return {
        ...state,
        onBeforeCapture: action.payload,
      };
    }
    case ADD_ASSET: {
      return {
        ...state,
        addAsset: action.payload,
      };
    }
    case SET_SIDE_BAR_EXERCISES_SEARCH_TERM: {
      return {
        ...state,
        sideBarExerciseSearchTerm: action.payload,
      };
    }
    case SET_EXERCISE_PICKER_SEARCH_TERM: {
      return {
        ...state,
        exercisePickerSearchTerm: action.payload,
      };
    }
    case SET_CALENDAR_CONTAINER_SCROLL_POSITION: {
      return {
        ...state,
        calendarContainerScrollPosition: action.payload,
      };
    }
    case SET_COMBINE_WITH_ID: {
      return {
        ...state,
        combineWithId: action.payload,
      };
    }
    case SET_CALENDAR_PANEL_CONTAINER_WIDTH: {
      return {
        ...state,
        calendarPanelContainerWidth: action.payload,
      };
    }
    case SET_ANIMATED_SIDEBAR_CONTAINER_WIDTH: {
      return {
        ...state,
        animatedSidebarContainerWidth: action.payload,
      };
    }
    case SET_HEADER_HEIGHT: {
      return {
        ...state,
        headerHeight: action.payload,
      };
    }
    case SET_IFRAMELY_ERROR: {
      return {
        ...state,
        iframelyError: action.payload,
      };
    }
    case FETCH_ALL_EXERCISES_START: {
      return {
        ...state,
        allExercises: [],
      };
    }
    case FETCH_ALL_EXERCISES_FULFILLED: {
      return {
        ...state,
        allExercises: action.payload,
      };
    }
    case FETCH_ALL_EXERCISES_REJECTED: {
      return {
        ...state,
        allExercisesError: action.payload,
      };
    }
    case FETCH_PREVIEW_WORKOUTS_START: {
      return {
        ...state,
        isPreviewWorkoutsLoading: true,
        previewWorkoutsError: null,
        latestPreviewRequestId: action.requestId,
        // Clear any stale program ids; the fulfilled handler repopulates them for program mode.
        previewDayBasedProgramId: null,
        previewDayBasedInstanceId: null,
      };
    }
    case FETCH_PREVIEW_WORKOUTS_FULFILLED: {
      // Ignore a response for a fetch that's since been superseded by a newer one.
      if (action.requestId !== state.latestPreviewRequestId) return state;
      return {
        ...state,
        isPreviewWorkoutsLoading: false,
        previewWorkoutItems: action.payload?.workoutItems || [],
        // Present only for free-form program fetches (null in date-based mode).
        previewDayBasedProgramId: action.payload?.dayBasedProgramId ?? null,
        previewDayBasedInstanceId: action.payload?.dayBasedInstanceId ?? null,
      };
    }
    case FETCH_PREVIEW_WORKOUTS_REJECTED: {
      // Ignore a rejection for a fetch that's since been superseded by a newer one.
      if (action.requestId !== state.latestPreviewRequestId) return state;
      return {
        ...state,
        isPreviewWorkoutsLoading: false,
        previewWorkoutItems: [],
        previewWorkoutsError: action.payload,
        previewDayBasedProgramId: null,
        previewDayBasedInstanceId: null,
      };
    }
    case SET_PREVIEW_ACTIVE_EXERCISE_INDEX: {
      return {
        ...state,
        previewActiveExerciseIndex: action.payload,
      };
    }
    case SET_PREVIEW_DATE: {
      return {
        ...state,
        previewDate: action.payload,
      };
    }
    case SET_PREVIEW_DAY_NUMBER: {
      return {
        ...state,
        previewDayNumber: action.payload,
      };
    }
    case FETCH_EXERCISE_FULFILLED: {
      return {
        ...state,
        recentlyFetchedExercise: action.payload,
      };
    }
    case FETCH_EXERCISE_REJECTED: {
      return {
        ...state,
        recentlyFetchedExercise: null,
      };
    }
    case FETCH_CALENDAR_ITEMS_START: {
      return {
        ...state,
        // Don't clear calendarItems - keep existing data during fetch
      };
    }
    case FETCH_CALENDAR_ITEMS_FULFILLED: {
      // Drop stale responses: if the user has switched calendar/athlete
      // since this request was made, the data no longer applies.
      const { selectionKey } = action?.payload || {};
      let currentKey = null;
      if (state.selectedReduxCalendar?.id) {
        currentKey = `calendar:${state.selectedReduxCalendar.id}`;
      } else if (state.selectedReduxAthlete?.id) {
        currentKey = `athlete:${state.selectedReduxAthlete.id}`;
      }
      if (selectionKey && currentKey && selectionKey !== currentKey) {
        return state;
      }

      const newData = action?.payload?.data || {};
      const requestedRange = action?.payload?.requestedRange;
      const mergedItems = {
        ...state.calendarItems,
        ...newData,
      };

      let nextExpandedItems = state.expandedItems;
      Object.keys(newData).forEach((dateKey) => {
        nextExpandedItems = withSessionBreaksExpanded(
          nextExpandedItems,
          newData[dateKey]?.exercises,
          state.calendarItems[dateKey]?.exercises,
        );
      });

      // Extend the range to include both old and new
      let newEarliest = state.calendarItemsDateRange.earliest;
      let newLatest = state.calendarItemsDateRange.latest;

      if (requestedRange) {
        if (!newEarliest || moment(requestedRange.start).isBefore(newEarliest)) {
          newEarliest = requestedRange.start;
        }
        if (!newLatest || moment(requestedRange.end).isAfter(newLatest)) {
          newLatest = requestedRange.end;
        }
      }

      return {
        ...state,
        shouldFetchRecurring: Date.now(),
        calendarItems: mergedItems,
        expandedItems: nextExpandedItems,
        calendarItemsDateRange: {
          /** removing these for now, they are causing
           * issues when trying to fetch historical data after
           * using new date picker to go to different years
           * we need to always be updating the earliest and latest calendarItemsDateRange
           * based on the last fetched data/ requested range
           */
          /** earliest: newEarliest, */
          /** latest: newLatest, */
          earliest: requestedRange?.start,
          latest: requestedRange?.end,
        },
      };
    }
    case FETCH_CALENDAR_ITEMS_REJECTED: {
      return {
        ...state,
        fetchCalendarItemsError: action.payload,
      };
    }
    case FETCH_CALENDAR_SELECT_ATHLETES_START: {
      return {
        ...state,
      };
    }
    case FETCH_CALENDAR_SELECT_ATHLETES_FULFILLED: {
      return {
        ...state,
        calendarSelectAthletes: action.payload,
      };
    }
    case FETCH_CALENDAR_SELECT_ATHLETES_REJECTED: {
      return {
        ...state,
        calendarSelectAthletesError: action.payload,
      };
    }
    case ADD_PRESAVED_ITEM_TO_CALENDAR_ITEMS_ARRAY: {
      const { item } = action.payload;
      const { date } = action.payload;
      const { destinationContainerIndex } = action.payload;
      const { droppableId } = action.payload;
      /** const index = action.payload.destinationContainerIndex; */

      const actualIndex = destinationContainerIndex ?? state.calendarItems[date]?.exercises.length ?? 0;

      // Prepare focus target for the newly added item
      const focusTarget = {
        itemIndex: actualIndex,
        assignedId: item.assignedId,
        timestamp: Date.now(),
      };

      // Handle week view day expansion when dropping into week-day containers
      let updatedExpandedItems;
      let { weekViewExpandedDay } = state;

      if (droppableId && droppableId.startsWith('week-day-')) {
        // Clear expanded items in other day columns when expanding a new day
        updatedExpandedItems = {
          [item.assignedId]: item,
        };
        weekViewExpandedDay = date; // Use the date of the dropped item
      } else {
        // Normal behavior - keep existing expanded items and add the new item
        updatedExpandedItems = {
          ...state.expandedItems,
          [item.assignedId]: item,
        };
      }

      if (state.calendarItems[date]) {
        return update(state, {
          calendarItems: {
            [date]: {
              exercises: {
                $splice: [
                  [actualIndex, 0, item], // using actualIndex here
                ],
              },
            },
          },
          expandedItems: { $set: updatedExpandedItems },
          focusTarget: { $set: focusTarget },
          mostRecentlyAddedCalendarItem: { $set: item },
          weekViewExpandedDay: { $set: weekViewExpandedDay },
          activeExerciseId: { $set: item.assignedId },
          currentBatchId: { $set: uuidv4() },
        });
      }
      const newCalendarItems = { ...state.calendarItems };
      newCalendarItems[date] = {
        date,
        exercises: [item],
        repCount: 0,
      };
      return {
        ...state,
        calendarItems: newCalendarItems,
        expandedItems: updatedExpandedItems,
        focusTarget,
        mostRecentlyAddedCalendarItem: item,
        weekViewExpandedDay,
        activeExerciseId: item.assignedId,
        currentBatchId: uuidv4(),
      };
    }

    case ADD_PRESAVED_ITEM_TO_PROGRAM_ITEMS_ARRAY: {
      const { item } = action.payload;
      const { programDayNumber } = action.payload;
      const { destinationContainerIndex } = action.payload;
      const { droppableId } = action.payload;

      const actualIndex = destinationContainerIndex ?? state.nonDateBasedProgramItems[programDayNumber]?.exercises?.length ?? 0;

      /** Prepare focus target for the newly added item */
      const focusTarget = {
        itemIndex: actualIndex,
        assignedId: item.assignedId,
        timestamp: Date.now(),
      };

      /** Handle week view day expansion when dropping into week-day containers */
      let updatedExpandedItems;
      let { weekViewExpandedDay } = state;

      if (droppableId && droppableId.startsWith('week-day-')) {
        /** Clear expanded items in other day columns when expanding a new day */
        updatedExpandedItems = {
          [item.assignedId]: item,
        };
        weekViewExpandedDay = Number(programDayNumber); // Use the date of the dropped item
      } else {
        /** Normal behavior - keep existing expanded items and add the new item */
        updatedExpandedItems = {
          ...state.expandedItems,
          [item.assignedId]: item,
        };
      }
      if (state.nonDateBasedProgramItems[programDayNumber]) {
        return update(state, {
          nonDateBasedProgramItems: {
            [programDayNumber]: {
              exercises: {
                $apply: (arr = []) => {
                  arr.splice(actualIndex, 0, item);
                  return arr;
                },
              },
            },
          },
          expandedItems: { $set: updatedExpandedItems },
          focusTarget: { $set: focusTarget },
          mostRecentlyAddedCalendarItem: { $set: item },
          weekViewExpandedDay: { $set: weekViewExpandedDay },
          activeExerciseId: { $set: item.assignedId },
          currentBatchId: { $set: uuidv4() },
        });
      }
      const newProgramItems = { ...state.nonDateBasedProgramItems };
      newProgramItems[programDayNumber] = {
        programDayNumber,
        exercises: [item],
        repCount: 0,
      };
      return {
        ...state,
        nonDateBasedProgramItems: newProgramItems,
        expandedItems: updatedExpandedItems,
        focusTarget,
        mostRecentlyAddedCalendarItem: item,
        weekViewExpandedDay,
        activeExerciseId: item.assignedId,
        currentBatchId: uuidv4(),
      };
    }

    case SAVE_CALENDAR_EXERCISE_FULFILLED: {
      /** The coach switched calendar/athlete/program while this save was in
       * flight. The item is saved on the previous selection; writing it here
       * would show it on the wrong one (the items were cleared on the switch,
       * so the day would be recreated holding just this item). It appears
       * when the coach goes back. The UI reducer still clears its saving flag. */
      if (action.payload.selectionKey
        && action.payload.selectionKey !== getCalendarSelectionKey(state)) {
        return state;
      }
      const newItem = action.payload.data;
      const { preSwappedAssignedId } = action.payload;
      const { selectedItems, expandedItems } = state;
      const calendarActionIdUpdate = buildCalendarActionSetPatch(action.payload, state.calendarAction, state.calendarActionBatchId);
      /** The item's assignedId changes from a presave temp id to the real backend id here. */
      const activeExerciseIdUpdate = buildActiveExerciseIdRemapPatch(state, preSwappedAssignedId, newItem.assignedId);

      /** --- Update selectedItems dictionary --- */
      let updatedSelectedItems = selectedItems;

      /** If the old item was selected, replace it with the new item */
      if (selectedItems[preSwappedAssignedId]) {
        const { [preSwappedAssignedId]: _, ...restSelectedItems } = selectedItems;
        updatedSelectedItems = {
          ...restSelectedItems,
          [newItem.assignedId]: newItem,
        };
      }

      const updatedExpandedItems = {
        ...expandedItems,
        /** if newItem type is a questionnaire, add it as expanded, else add the new item as collapsed */
        [newItem.assignedId]: newItem?.type === 'questionnaire' || newItem?.type === 'session_break',
      };

      if (state.calendarItems[action.payload.formattedDate]) {
        const { formattedDate, itemIndex } = action.payload;
        const currentExercises = state.calendarItems[formattedDate]?.exercises || [];

        /** Resolve by the pre-save temp id (or the new numeric id, in case
         * the slot already has it) so a drag during the in-flight save
         * can't land response data at a stale index. */
        const foundIndex = currentExercises.findIndex(
          (ex) => ex.assignedId === preSwappedAssignedId
            || ex.assignedId === newItem.assignedId,
        );
        const slotId = currentExercises[itemIndex]?.assignedId;
        const fallbackIndex = (slotId === preSwappedAssignedId || slotId === newItem.assignedId)
          ? itemIndex
          : -1;
        const targetIndex = foundIndex !== -1 ? foundIndex : fallbackIndex;

        /** Pure create from the modal (no placeholder to replace): insert at itemIndex.
         * The auto-save hook passes exercises.length, i.e. append. If foundIndex !== -1
         * an optimistic add already landed, so fall through to the replace path. */
        if (targetIndex === -1 && !preSwappedAssignedId && foundIndex === -1) {
          const insertIndex = Math.min(itemIndex, currentExercises.length);
          const insertedExercises = [
            ...currentExercises.slice(0, insertIndex),
            newItem,
            ...currentExercises.slice(insertIndex),
          ];
          const { dateSetCount: insertedSetCount, dateRepCount: insertedRepCount } = insertedExercises.reduce(
            (totals, exercise) => ({
              dateSetCount: totals.dateSetCount + (exercise.setCount || 0),
              dateRepCount: totals.dateRepCount + (exercise.repCount || 0),
            }),
            { dateSetCount: 0, dateRepCount: 0 },
          );

          return update(state, {
            calendarItems: {
              [formattedDate]: {
                exercises: { $splice: [[insertIndex, 0, newItem]] },
                setCount: { $set: insertedSetCount },
                repCount: { $set: insertedRepCount },
                lastUpdatedTimestamp: { $set: Date.now() },
              },
            },
            selectedItems: { $set: updatedSelectedItems },
            expandedItems: { $set: updatedExpandedItems },
            mostRecentlyAddedCalendarItem: { $set: newItem },
            shouldFetchRecurring: { $set: Date.now() },
            ...calendarActionIdUpdate,
            ...activeExerciseIdUpdate,
          });
        }

        if (targetIndex === -1) {
          return state;
        }

        // Calculate date-level totals after updating this exercise
        const { dateSetCount, dateRepCount } = currentExercises.reduce(
          (totals, exercise, index) => {
            const exerciseToUse = index === targetIndex ? newItem : exercise;
            return {
              dateSetCount: totals.dateSetCount + (exerciseToUse.setCount || 0),
              dateRepCount: totals.dateRepCount + (exerciseToUse.repCount || 0),
            };
          },
          { dateSetCount: 0, dateRepCount: 0 },
        );

        return update(state, {
          calendarItems: {
            [formattedDate]: {
              exercises: {
                [targetIndex]: {
                  $set: newItem,
                },
              },
              setCount: {
                $set: dateSetCount,
              },
              repCount: {
                $set: dateRepCount,
              },
              lastUpdatedTimestamp: {
                $set: Date.now(),
              },
            },
          },
          selectedItems: { $set: updatedSelectedItems },
          expandedItems: { $set: updatedExpandedItems },
          mostRecentlyAddedCalendarItem: { $set: newItem },
          /** Publish the id migration so a consumer holding the pre-save id can
           * follow the item rather than treating it as deleted. Only this
           * in-place branch is reached with a preSwappedAssignedId. */
          lastPreSaveIdSwap: {
            $set: { from: preSwappedAssignedId, to: newItem.assignedId },
          },
          shouldFetchRecurring: { $set: Date.now() },
          ...calendarActionIdUpdate,
          ...activeExerciseIdUpdate,
        });
      }
      const newDate = action.payload.formattedDate;
      const newExercises = [action.payload.data];

      // Calculate date-level totals from all exercises for this new date
      const { dateSetCount, dateRepCount } = newExercises.reduce(
        (totals, exercise) => ({
          dateSetCount: totals.dateSetCount + (exercise.setCount || 0),
          dateRepCount: totals.dateRepCount + (exercise.repCount || 0),
        }),
        { dateSetCount: 0, dateRepCount: 0 },
      );

      const newCalendarItems = { ...state.calendarItems };
      newCalendarItems[newDate] = {
        date: newDate,
        exercises: newExercises,
        setCount: dateSetCount,
        repCount: dateRepCount,
        lastUpdatedTimestamp: Date.now(),
      };

      return {
        ...state,
        calendarItems: newCalendarItems,
        mostRecentlyAddedCalendarItem: newItem,
        activeExerciseId: state.activeExerciseId === preSwappedAssignedId
          ? newItem.assignedId
          : state.activeExerciseId,
        ...buildCalendarActionField(action.payload),
        // This path bypasses buildCalendarActionSetPatch (no merge check
        // needed here), so nothing sets calendarActionBatchId to match the
        // calendarAction just set above - reset it so a future batchId can
        // never spuriously collide with a stale leftover value.
        calendarActionBatchId: null,
      };
    }

    case SAVE_NON_DATE_BASED_WORKOUT_EXERCISE_FULFILLED: {
      /** The coach switched calendar/athlete/program while this save was in
       * flight. The item is saved on the previous selection; writing it here
       * would show it on the wrong one (the items were cleared on the switch,
       * so the day would be recreated holding just this item). It appears
       * when the coach goes back. The UI reducer still clears its saving flag. */
      if (action.payload.selectionKey
        && action.payload.selectionKey !== getCalendarSelectionKey(state)) {
        return state;
      }
      const newItem = action.payload.data;
      const { preSwappedAssignedId } = action.payload;
      const { selectedItems, expandedItems } = state;
      /** Same presave-temp-id -> real-id swap as SAVE_CALENDAR_EXERCISE_FULFILLED above. */
      const activeExerciseIdUpdate = buildActiveExerciseIdRemapPatch(state, preSwappedAssignedId, newItem.assignedId);

      /** --- Update selectedItems dictionary --- */
      let updatedSelectedItems = selectedItems;

      /** If the old item was selected, replace it with the new item */
      if (selectedItems[preSwappedAssignedId]) {
        const { [preSwappedAssignedId]: _, ...restSelectedItems } = selectedItems;
        updatedSelectedItems = {
          ...restSelectedItems,
          [newItem.assignedId]: newItem,
        };
      }

      const updatedExpandedItems = {
        ...expandedItems,
        /** if newItem type is a questionnaire, add it as expanded, else add the new item as collapsed */
        [newItem.assignedId]: newItem?.type === 'questionnaire' || newItem?.type === 'session_break',
      };

      if (state.nonDateBasedProgramItems[action.payload.dayNumber]) {
        const { dayNumber, itemIndex } = action.payload;
        const currentExercises = state.nonDateBasedProgramItems[dayNumber]?.exercises || [];

        /** Resolve by the pre-save temp id (or the new numeric id, in case
         * the slot already has it) so a drag during the in-flight save
         * can't land response data at a stale index. */
        const foundIndex = currentExercises.findIndex(
          (ex) => ex.assignedId === preSwappedAssignedId
            || ex.assignedId === newItem.assignedId,
        );
        const slotId = currentExercises[itemIndex]?.assignedId;
        const fallbackIndex = (slotId === preSwappedAssignedId || slotId === newItem.assignedId)
          ? itemIndex
          : -1;
        const targetIndex = foundIndex !== -1 ? foundIndex : fallbackIndex;

        /** Pure create from the modal (no placeholder to replace): insert at itemIndex.
         * The auto-save hook passes exercises.length, i.e. append. If foundIndex !== -1
         * an optimistic add already landed, so fall through to the replace path. */
        if (targetIndex === -1 && !preSwappedAssignedId && foundIndex === -1) {
          const insertIndex = Math.min(itemIndex, currentExercises.length);
          const insertedExercises = [
            ...currentExercises.slice(0, insertIndex),
            newItem,
            ...currentExercises.slice(insertIndex),
          ];
          const { dateSetCount: insertedSetCount, dateRepCount: insertedRepCount } = insertedExercises.reduce(
            (totals, exercise) => ({
              dateSetCount: totals.dateSetCount + (exercise.setCount || 0),
              dateRepCount: totals.dateRepCount + (exercise.repCount || 0),
            }),
            { dateSetCount: 0, dateRepCount: 0 },
          );

          return update(state, {
            nonDateBasedProgramItems: {
              [dayNumber]: {
                exercises: { $splice: [[insertIndex, 0, newItem]] },
                setCount: { $set: insertedSetCount },
                repCount: { $set: insertedRepCount },
                lastUpdatedTimestamp: { $set: Date.now() },
              },
            },
            selectedItems: { $set: updatedSelectedItems },
            expandedItems: { $set: updatedExpandedItems },
            mostRecentlyAddedCalendarItem: { $set: newItem },
            ...activeExerciseIdUpdate,
          });
        }

        if (targetIndex === -1) {
          return state;
        }

        // Calculate date-level totals after updating this exercise
        const { dateSetCount, dateRepCount } = currentExercises.reduce(
          (totals, exercise, index) => {
            const exerciseToUse = index === targetIndex ? newItem : exercise;
            return {
              dateSetCount: totals.dateSetCount + (exerciseToUse.setCount || 0),
              dateRepCount: totals.dateRepCount + (exerciseToUse.repCount || 0),
            };
          },
          { dateSetCount: 0, dateRepCount: 0 },
        );

        return update(state, {
          nonDateBasedProgramItems: {
            [dayNumber]: {
              exercises: {
                [targetIndex]: {
                  $set: newItem,
                },
              },
              setCount: {
                $set: dateSetCount,
              },
              repCount: {
                $set: dateRepCount,
              },
              lastUpdatedTimestamp: {
                $set: Date.now(),
              },
            },
          },
          selectedItems: { $set: updatedSelectedItems },
          expandedItems: { $set: updatedExpandedItems },
          mostRecentlyAddedCalendarItem: { $set: newItem },
          /** See the matching publish in SAVE_CALENDAR_EXERCISE_FULFILLED. */
          lastPreSaveIdSwap: {
            $set: { from: preSwappedAssignedId, to: newItem.assignedId },
          },
          ...activeExerciseIdUpdate,
        });
      }
      // const newDate = action.payload.formattedDate;
      const newDay = action.payload.dayNumber;
      const newExercises = [action.payload.data];

      // Calculate date-level totals from all exercises for this new date
      const { dateSetCount, dateRepCount } = newExercises.reduce(
        (totals, exercise) => ({
          dateSetCount: totals.dateSetCount + (exercise.setCount || 0),
          dateRepCount: totals.dateRepCount + (exercise.repCount || 0),
        }),
        { dateSetCount: 0, dateRepCount: 0 },
      );

      const newProgramItems = { ...state.nonDateBasedProgramItems };
      newProgramItems[newDay] = {
        dayInWeek: action.payload.data.dayInWeek,
        dayNumber: newDay,
        exercises: newExercises,
        repCount: dateRepCount,
        setCount: dateSetCount,
        weekNumber: action.payload.data.weekNumber,
        lastUpdatedTimestamp: Date.now(),
      };

      return {
        ...state,
        nonDateBasedProgramItems: newProgramItems,
        mostRecentlyAddedCalendarItem: newItem,
        activeExerciseId: state.activeExerciseId === preSwappedAssignedId
          ? newItem.assignedId
          : state.activeExerciseId,
      };
    }
    case SET_CALENDAR_ITEMS: {
      const nextExpandedItems = withSessionBreaksExpanded(
        state.expandedItems,
        action.payload.calendarItemsArray,
        state.calendarItems[action.payload.date]?.exercises,
      );
      // Ensure the date object exists before updating
      const dateExists = state.calendarItems[action.payload.date];
      if (!dateExists) {
        return update(state, {
          calendarItems: {
            [action.payload.date]: {
              $set: {
                exercises: action.payload.calendarItemsArray,
              },
            },
          },
          expandedItems: { $set: nextExpandedItems },
        });
      }
      return update(state, {
        calendarItems: {
          [action.payload.date]: {
            exercises: {
              $set: action.payload.calendarItemsArray,
            },
          },
        },
        expandedItems: { $set: nextExpandedItems },
      });
    }
    case SET_NON_DATE_BASED_PROGRAM_DAYS: {
      const programDays = action.payload.programDays || [];
      let nextExpandedItems = state.expandedItems;
      Object.keys(programDays).forEach((dayKey) => {
        nextExpandedItems = withSessionBreaksExpanded(
          nextExpandedItems,
          programDays[dayKey]?.exercises,
          state.nonDateBasedProgramItems[dayKey]?.exercises,
        );
      });
      return {
        ...state,
        nonDateBasedProgramItems: action.payload.programDays,
        expandedItems: nextExpandedItems,
      };
    }
    case SET_NON_DATE_BASED_PROGRAM_ITEMS: {
      const nextExpandedItems = withSessionBreaksExpanded(
        state.expandedItems,
        action.payload.programItemsArray,
        state.nonDateBasedProgramItems[action.payload.programDayNumber]?.exercises,
      );
      // Ensure the day number object exists before updating
      const programDayNumberExists = state.nonDateBasedProgramItems[action.payload.programDayNumber];
      if (!programDayNumberExists) {
        return update(state, {
          nonDateBasedProgramItems: {
            [action.payload.programDayNumber]: {
              $set: {
                exercises: action.payload.programItemsArray,
              },
            },
          },
          expandedItems: { $set: nextExpandedItems },
        });
      }
      return update(state, {
        nonDateBasedProgramItems: {
          [action.payload.programDayNumber]: {
            exercises: {
              $set: action.payload.programItemsArray,
            },
          },
        },
        expandedItems: { $set: nextExpandedItems },
      });
    }

    case SET_RECURRING_CALENDAR_ITEMS: {
      const { beforeOrAfter } = action.payload;
      if (beforeOrAfter === 'before') {
        return update(state, {
          beforeRecurringWorkouts: {
            [action.payload.formattedDate]: {
              $set: action.payload.calendarItemsArray,
            },
          },
        });
      }
      if (beforeOrAfter === 'after') {
        return update(state, {
          afterRecurringWorkouts: {
            [action.payload.formattedDate]: {
              $set: action.payload.calendarItemsArray,
            },
          },
        });
      }
      return {
        ...state,
      };
    }

    case CLEAR_BEFORE_RECURRING_CALENDAR_ITEMS: {
      return {
        ...state,
        beforeRecurringWorkouts: {},
      };
    }

    case CLEAR_AFTER_RECURRING_CALENDAR_ITEMS: {
      return {
        ...state,
        afterRecurringWorkouts: {},
      };
    }

    case CLEAR_CALENDAR_ITEMS: {
      return {
        ...state,
        calendarItems: {},
      };
    }
    case CLEAR_WORKOUT_ITEMS_FULFILLED: {
      // Like COPY below: bump calendarActionSetAt so HistorySideBarContent's
      // refetch effect (which watches that timestamp, not calendarAction's
      // reference) fires and the new "clear" action shows up without the coach
      // having to close and reopen the undo tab. The clear endpoint does return
      // a real calendarAction, so buildCalendarActionField also picks that up.
      return {
        ...state,
        ...buildCalendarActionField(action.payload),
        calendarActionSetAt: Date.now(),
        // Bypasses buildCalendarActionSetPatch - reset so a stale leftover
        // batchId can never spuriously match a future request's.
        calendarActionBatchId: null,
      };
    }
    case LOAD_SAVED_PROGRAM_FULFILLED: {
      return {
        ...state,
        ...buildCalendarActionField(action.payload),
        // Same as CLEAR above - the history sidebar refetches on this bump.
        calendarActionSetAt: Date.now(),
        // Bypasses buildCalendarActionSetPatch - reset so a stale leftover
        // batchId can never spuriously match a future request's.
        calendarActionBatchId: null,
      };
    }
    case COPY_WORKOUT_ITEMS_FULFILLED: {
      // A copy always creates new Calendar_Actions rows server-side, and the
      // copy-assignments endpoint returns the resulting calendarAction, which
      // buildCalendarActionField picks up as the header Undo target. This
      // bypasses buildCalendarActionSetPatch, so bump calendarActionSetAt here
      // - the field HistorySideBarContent's refetch effect watches - or the
      // copy never appears in history until some later mutation bumps it.
      return {
        ...state,
        ...buildCalendarActionField(action.payload),
        calendarActionSetAt: Date.now(),
        // Bypasses buildCalendarActionSetPatch - reset so a stale leftover
        // batchId can never spuriously match a future request's.
        calendarActionBatchId: null,
      };
    }
    case CLEAR_NON_DATE_BASED_PROGRAM_ITEMS: {
      return {
        ...state,
        nonDateBasedProgramItems: [],
      };
    }
    case SAVE_CALENDAR_EXERCISE_REJECTED: {
      return {
        ...state,
        fetchCalendarItemsError: action.payload?.message,
      };
    }
    case UPLOAD_CALENDAR_MEDIA_FULFILLED: {
      return {
        ...state,
        uploadedMedia: action.payload,
      };
    }
    case UPLOAD_CALENDAR_MEDIA_REJECTED: {
      return {
        ...state,
        uploadedMedia: null,
      };
    }
    case EDIT_THUMBNAIL_FULFUILLED: {
      return {
        ...state,
        /** replace current uploadedMedia with edited thumbnail media */
        uploadedMedia: action.payload,
      };
    }
    case CREATE_EXERCISE_FULFILLED: {
      const itemSavedToDatabase = action.payload?.reusableItem === 1;

      return {
        ...state,
        allExercises: itemSavedToDatabase
          ? [...state.allExercises, action.payload].sort((a, b) => a.name.localeCompare(b.name))
          : state.allExercises, /** don't add if not saved to data base */
        newlyCreatedExercise: action.payload,
      };
    }
    case CREATE_TAG_FOR_ACCOUNT_FULTILLED: {
      return {
        ...state,
        tagsForAccount: [...state.tagsForAccount, action.payload],
        newlyCreatedTag: action.payload,
      };
    }
    case FETCH_ACCOUNT_TAGS_FULFILLED: {
      return {
        ...state,
        tagsForAccount: action.payload,
      };
    }
    // Merge-spread: the PUT response has no `exercises` key, so the fetched
    // associations on the existing entry survive the update.
    case UPDATE_TAG_FOR_ACCOUNT_FULFILLED: {
      return {
        ...state,
        tagsForAccount: state.tagsForAccount.map(
          (tag) => (tag.id === action.payload.id ? { ...tag, ...action.payload } : tag),
        ),
      };
    }
    case DELETE_TAGS_FOR_ACCOUNT_FULFILLED: {
      return {
        ...state,
        tagsForAccount: state.tagsForAccount.filter(
          (tag) => !action.payload.includes(tag.id),
        ),
      };
    }
    case CREATE_PROGRAM_TAG_FULFILLED: {
      return {
        ...state,
        tagsForAllPrograms: [...state.tagsForAllPrograms, action.payload],
        newlyCreatedProgramTag: action.payload,
      };
    }
    case FETCH_PROGRAM_TAGS_FULFILLED: {
      return {
        ...state,
        tagsForAllPrograms: action.payload,
      };
    }
    case UPDATE_PROGRAM_TAG_FULFILLED: {
      return {
        ...state,
        tagsForAllPrograms: state.tagsForAllPrograms.map(
          (tag) => (tag.id === action.payload.id ? { ...tag, ...action.payload } : tag),
        ),
      };
    }
    case DELETE_PROGRAM_TAGS_FULFILLED: {
      return {
        ...state,
        tagsForAllPrograms: state.tagsForAllPrograms.filter(
          (tag) => !action.payload.includes(tag.id),
        ),
      };
    }
    case SET_ADD_INFO_CONTENT: {
      return {
        ...state,
        addInfoContent: action.payload,
      };
    }
    case FETCH_DOCUMENTS_FULFILLED: {
      return {
        ...state,
        documents: action.payload,
      };
    }
    case FETCH_DOCUMENT_FULFILLED: {
      return {
        ...state,
        fetchedDocument: action.payload,
      };
    }
    case FETCH_FOLDER_FULFILLED: {
      return {
        ...state,
        folderDocuments: action.payload,
      };
    }
    case UPDATE_SAVED_WORKOUT_ITEM_FULFILLED: {
      const newItem = action.payload.data;
      const { dayNumber, itemIndex } = action.payload;
      const currentExercises = state.nonDateBasedProgramItems[dayNumber]?.exercises || [];

      /** Resolve by assignedId so a drag during the in-flight update can't
       * land response data at a stale index. */
      const foundIndex = currentExercises.findIndex(
        (ex) => ex.assignedId === newItem.assignedId,
      );
      const fallbackIndex = currentExercises[itemIndex]?.assignedId === newItem.assignedId
        ? itemIndex
        : -1;
      const targetIndex = foundIndex !== -1 ? foundIndex : fallbackIndex;

      if (targetIndex === -1) {
        return state;
      }

      // Calculate date-level totals after updating this exercise
      const { dateSetCount, dateRepCount } = currentExercises.reduce(
        (totals, exercise, index) => {
          const exerciseToUse = index === targetIndex ? newItem : exercise;
          return {
            dateSetCount: totals.dateSetCount + (exerciseToUse.setCount || 0),
            dateRepCount: totals.dateRepCount + (exerciseToUse.repCount || 0),
          };
        },
        { dateSetCount: 0, dateRepCount: 0 },
      );

      return update(state, {
        nonDateBasedProgramItems: {
          [dayNumber]: {
            exercises: {
              [targetIndex]: {
                $set: newItem,
              },
            },
            setCount: {
              $set: dateSetCount,
            },
            repCount: {
              $set: dateRepCount,
            },
            lastUpdatedTimestamp: {
              $set: Date.now(),
            },
          },
        },
      });
    }
    case UPDATE_PROGRAMMED_CALENDAR_ITEM_FULFILLED: {
      const newItem = action.payload.data;
      const calendarActionIdUpdate = buildCalendarActionSetPatch(action.payload, state.calendarAction, state.calendarActionBatchId);
      /** A newer update for this item is queued behind this one, so this
       * response is already out of date - writing it would briefly revert the
       * item (and any table re-syncing from it) to older values. Its undo entry
       * is still real, so only that part is applied. */
      if (action.payload.superseded) {
        return Object.keys(calendarActionIdUpdate).length
          ? update(state, calendarActionIdUpdate)
          : state;
      }
      if (action.payload.isRecurring && action.payload.isRecurring === 'before') {
        return update(state, {
          beforeRecurringWorkouts: {
            [action.payload.formattedDate]: {
              [action.payload.itemIndex]: {
                $set: newItem,
              },
            },
          },
          ...(action.payload.reverted ? {} : { shouldFetchRecurring: { $set: Date.now() } }),
          ...calendarActionIdUpdate,
        });
      }
      if (action.payload.isRecurring && action.payload.isRecurring === 'after') {
        return update(state, {
          afterRecurringWorkouts: {
            [action.payload.formattedDate]: {
              [action.payload.itemIndex]: {
                $set: newItem,
              },
            },
          },
          ...(action.payload.reverted ? {} : { shouldFetchRecurring: { $set: Date.now() } }),
          ...calendarActionIdUpdate,
        });
      }
      const { formattedDate, itemIndex } = action.payload;
      const currentExercises = state.calendarItems[formattedDate]?.exercises || [];

      /** Resolve by assignedId so a drag during the in-flight update can't
       * land response data at a stale index. */
      const foundIndex = currentExercises.findIndex(
        (ex) => ex.assignedId === newItem.assignedId,
      );
      const fallbackIndex = currentExercises[itemIndex]?.assignedId === newItem.assignedId
        ? itemIndex
        : -1;
      const targetIndex = foundIndex !== -1 ? foundIndex : fallbackIndex;

      if (targetIndex === -1) {
        return state;
      }

      // Calculate date-level totals after updating this exercise
      const { dateSetCount, dateRepCount } = currentExercises.reduce(
        (totals, exercise, index) => {
          const exerciseToUse = index === targetIndex ? newItem : exercise;
          return {
            dateSetCount: totals.dateSetCount + (exerciseToUse.setCount || 0),
            dateRepCount: totals.dateRepCount + (exerciseToUse.repCount || 0),
          };
        },
        { dateSetCount: 0, dateRepCount: 0 },
      );

      return update(state, {
        calendarItems: {
          [formattedDate]: {
            exercises: {
              [targetIndex]: {
                $set: newItem,
              },
            },
            setCount: {
              $set: dateSetCount,
            },
            repCount: {
              $set: dateRepCount,
            },
            lastUpdatedTimestamp: {
              $set: Date.now(),
            },
          },
        },
        ...calendarActionIdUpdate,
      });
    }
    case UPDATE_CALENDAR_ITEMS_ORDER_FULFILLED: {
      const calendarActionUpdate = buildCalendarActionSetPatch(action.payload, state.calendarAction, state.calendarActionBatchId);
      if (Object.keys(calendarActionUpdate).length) {
        return update(state, calendarActionUpdate);
      }
      return state;
    }
    case UPDATE_FUTURE_OCCURRENCES_PROGRAMMED_CALENDAR_ITEM_FULFILLED: {
      const calendarActionUpdate = buildCalendarActionSetPatch(action.payload, state.calendarAction, state.calendarActionBatchId);
      if (Object.keys(calendarActionUpdate).length) {
        return update(state, calendarActionUpdate);
      }
      return state;
    }
    case UNDO_CALENDAR_ACTION_START: {
      return update(state, {
        isUndoingCalendarAction: { $set: true },
      });
    }
    case UNDO_CALENDAR_ACTION_FULFILLED: {
      // An undo just reverted the current edit session's action, so its
      // batchId is now dead. Regenerate currentBatchId so the next edit to the
      // still-active item starts a fresh, not-already-undone batch (and
      // subsequent edits batch under that new one, since activeExerciseId is
      // untouched) rather than re-attaching to the undone action. The undo
      // cascade sweeps forward (id > targetActionId) and the current session is
      // always the newest action, so any undo includes the current batch -
      // regenerating is always correct here. Mint (not null) so the follow-up
      // edits still group together instead of each minting their own.
      const { selectionKey } = action.payload;
      if (selectionKey && selectionKey !== getCalendarSelectionKey(state)) {
        // The user switched calendar/athlete/program while this undo was in
        // flight - its calendarAction belongs to the previous selection, and
        // writing it back would recreate the stale Undo target the selection
        // reset just cleared. Only end the loading state.
        return update(state, {
          isUndoingCalendarAction: { $set: false },
          currentBatchId: { $set: uuidv4() },
        });
      }
      return update(state, {
        ...buildCalendarActionSetPatch(action.payload, state.calendarAction, state.calendarActionBatchId),
        isUndoingCalendarAction: { $set: false },
        currentBatchId: { $set: uuidv4() },
        // Unconditional: an undo just succeeded - whatever was selected in
        // the history sidebar is done being a valid boundary to keep showing
        // as selected, regardless of which undo path fired (header button,
        // Cmd/Ctrl+Z, or the sidebar's own button) or what the cascade
        // actually reverted. No refetch/inference needed for this - it's
        // cleared here, directly, the moment the undo itself resolves.
        selectedHistoryEntryId: { $set: null },
      });
    }
    case UNDO_CALENDAR_ACTION_REJECTED: {
      return update(state, {
        isUndoingCalendarAction: { $set: false },
      });
    }
    case SET_CALENDAR_ACTION_EXPIRED: {
      /** Fired when undoCalendarAction hits a stale click - the target's
       * expiresAt had already passed by the time the request would have gone
       * out, so it never hit the network. Nothing about the data actually
       * changed (the real expiresAt/canBeUndone are unchanged), but the
       * components reading calendarAction/calendarActionHistory only
       * re-evaluate their own "is this still eligible" checks on render, so a
       * stale click needs a fresh object reference to force that re-check to
       * happen right now instead of on the next unrelated render. */
      const { id } = action.payload;
      const patch = {};
      if (state.calendarAction?.id === id) {
        patch.calendarAction = { $set: { ...state.calendarAction } };
      }
      const historyIndex = state.calendarActionHistory.findIndex((entry) => entry.id === id);
      if (historyIndex !== -1) {
        patch.calendarActionHistory = {
          [historyIndex]: { $set: { ...state.calendarActionHistory[historyIndex] } },
        };
      }
      return Object.keys(patch).length ? update(state, patch) : state;
    }
    case FETCH_CALENDAR_ACTION_HISTORY_START: {
      return update(state, {
        isFetchingCalendarActionHistory: { $set: true },
        calendarActionHistoryError: { $set: null },
      });
    }
    case FETCH_CALENDAR_ACTION_HISTORY_FULFILLED: {
      return update(state, {
        calendarActionHistory: { $set: action.payload },
        isFetchingCalendarActionHistory: { $set: false },
      });
    }
    case FETCH_CALENDAR_ACTION_HISTORY_REJECTED: {
      return update(state, {
        isFetchingCalendarActionHistory: { $set: false },
        calendarActionHistoryError: { $set: action.payload },
      });
    }
    case SET_SELECTED_HISTORY_ENTRY_ID: {
      return update(state, {
        selectedHistoryEntryId: { $set: action.payload },
      });
    }
    case RECORD_GESTURE_PARTICIPANT_COUNT: {
      return update(state, {
        gestureParticipantCountByBatchId: {
          $merge: { [action.payload.batchId]: action.payload.participantCount },
        },
      });
    }
    case SWAP_PROGRAMMED_ITEM_ON_CHILD_CALENDAR_FULFILLED: {
      const newItem = action.payload.data;
      const { preSwappedAssignedId } = action.payload;
      const { selectedItems, expandedItems } = state;

      /** --- Update selectedItems dictionary --- */
      let updatedSelectedItems = selectedItems;

      /** If the old item was selected, replace it with the new item */
      if (selectedItems[preSwappedAssignedId]) {
        const { [preSwappedAssignedId]: _, ...restSelectedItems } = selectedItems;
        updatedSelectedItems = {
          ...restSelectedItems,
          [newItem.assignedId]: newItem,
        };
      }

      /** Update expandedItems object */
      /** if the pre swapped assigned id was in the expandedItems object
       * then the new swapped item should be expanded because we are updating
       * an item that is expanded.
       */
      const updatedExpandedItems = { ...expandedItems };

      if (updatedExpandedItems[preSwappedAssignedId] !== undefined) {
        updatedExpandedItems[newItem.assignedId] = updatedExpandedItems[preSwappedAssignedId];
      }

      /** The item's assignedId changes here too (parent item materializes into
       * an athlete-level copy). */
      const activeExerciseIdUpdate = buildActiveExerciseIdRemapPatch(state, preSwappedAssignedId, newItem.assignedId);

      return update(state, {
        calendarItems: {
          [action.payload.formattedDate]: {
            exercises: {
              [action.payload.itemIndex]: {
                $set: newItem,
              },
            },
          },
        },
        selectedItems: { $set: updatedSelectedItems },
        expandedItems: { $set: updatedExpandedItems },
        ...buildCalendarActionSetPatch(action.payload, state.calendarAction, state.calendarActionBatchId),
        ...activeExerciseIdUpdate,
      });
    }

    case REVERT_SWAPPED_ITEM_FULFILLED: {
      const newItem = action.payload.data;
      const { preRevertedAssignedId } = action.payload;
      const { selectedItems, expandedItems } = state;

      /** --- Update selectedItems dictionary --- */
      let updatedSelectedItems = selectedItems;

      /** If the old item was selected, replace it with the new item */
      if (selectedItems[preRevertedAssignedId]) {
        const { [preRevertedAssignedId]: _, ...restSelectedItems } = selectedItems;
        updatedSelectedItems = {
          ...restSelectedItems,
          [newItem.assignedId]: newItem,
        };
      }

      /** Update expandedItems object */
      /** if the pre swapped assigned id was in the expandedItems object
       * then the new swapped item should be expanded because we are updating
       * an item that is expanded.
       */
      const updatedExpandedItems = { ...expandedItems };

      if (updatedExpandedItems[preRevertedAssignedId] !== undefined) {
        updatedExpandedItems[newItem.assignedId] = updatedExpandedItems[preRevertedAssignedId];
      }
      return update(state, {
        calendarItems: {
          [action.payload.formattedDate]: {
            exercises: {
              [action.payload.itemIndex]: {
                $set: newItem,
              },
            },
          },
        },
        selectedItems: { $set: updatedSelectedItems },
        expandedItems: { $set: updatedExpandedItems },
      });
    }
    case UPDATE_PRESAVED_CALENDAR_ITEM: {
      const updatedItem = action.payload.item;
      return update(state, {
        calendarItems: {
          [action.payload.date]: {
            exercises: {
              [action.payload.destinationContainerIndex]: {
                $set: updatedItem,
              },
            },
          },
        },
      });
    }

    case UPDATE_PRESAVED_PROGRAM_ITEM: {
      const updatedItem = action.payload.item;
      return update(state, {
        nonDateBasedProgramItems: {
          [action.payload.programDayNumber]: {
            exercises: {
              [action.payload.destinationContainerIndex]: {
                $set: updatedItem,
              },
            },
          },
        },
      });
    }

    case DELETE_RECURRING_ITEM_FULFILLED: {
      const calendarActionUpdate = buildCalendarActionSetPatch(action.payload, state.calendarAction, state.calendarActionBatchId);
      // A successful delete ends its batch too, same precedent as
      // CONVERT_RECURRING_ITEM_FULFILLED/UPDATE_RECURRING_ITEM_SCHEDULE_FULFILLED -
      // otherwise a later action that happens to reactivate this batch context
      // could inherit the delete's batchId.
      return update(state, {
        ...calendarActionUpdate,
        currentBatchId: { $set: uuidv4() },
      });
    }

    case DELETE_SAVED_CALENDAR_ITEM_FULFILLED: {
      const { date, assignedIds } = action.payload.data;
      const calendarActionIdUpdate = buildCalendarActionSetPatch(action.payload, state.calendarAction, state.calendarActionBatchId);

      const removeByAssignedIds = (items) => items.filter(
        (item) => !assignedIds.includes(item.assignedId),
      );

      /** Remove deleted items from selectedItems */
      const updatedSelectedItems = { ...state.selectedItems };
      assignedIds.forEach((id) => {
        delete updatedSelectedItems[id];
      });

      /** Capture deleted items with their indices for undo */
      const currentExercises = state.calendarItems[date]?.exercises || [];
      const deletedItemsWithIndices = [];
      currentExercises.forEach((item, idx) => {
        if (assignedIds.includes(item.assignedId)) {
          deletedItemsWithIndices.push({ item, index: idx });
        }
      });

      const remainingExercises = removeByAssignedIds(currentExercises);

      // Calculate date-level totals from remaining exercises
      const { dateSetCount, dateRepCount } = remainingExercises.reduce(
        (totals, exercise) => ({
          dateSetCount: totals.dateSetCount + (exercise.setCount || 0),
          dateRepCount: totals.dateRepCount + (exercise.repCount || 0),
        }),
        { dateSetCount: 0, dateRepCount: 0 },
      );

      return update(state, {
        calendarItems: {
          [date]: {
            exercises: {
              $apply: removeByAssignedIds,
            },
            setCount: {
              $set: dateSetCount,
            },
            repCount: {
              $set: dateRepCount,
            },
          },
        },
        selectedItems: { $set: updatedSelectedItems },
        shouldFetchRecurring: { $set: Date.now() },
        undoDeleteMetadata: {
          [[...assignedIds].sort().join(',')]: {
            $set: { kind: 'calendar', date, deletedItemsWithIndices },
          },
        },
        ...calendarActionIdUpdate,
      });
    }
    case DELETE_SAVED_WORKOUT_ITEM_FULFILLED: {
      const { dayNumber, assignedIds } = action.payload.data;

      const removeByAssignedIds = (items) => items.filter((item) => !assignedIds.includes(item.assignedId));

      /** Calculate updated totals after deletion */
      const currentExercises = state.nonDateBasedProgramItems[dayNumber]?.exercises || [];
      const remainingExercises = removeByAssignedIds(currentExercises);

      /** Capture deleted items with their original indices for undo */
      const deletedItemsWithIndices = [];
      currentExercises.forEach((item, idx) => {
        if (assignedIds.includes(item.assignedId)) {
          deletedItemsWithIndices.push({ item, index: idx });
        }
      });

      /** Remove deleted items from selectedItems */
      const updatedSelectedItems = { ...state.selectedItems };
      assignedIds.forEach((id) => {
        delete updatedSelectedItems[id];
      });

      /** Calculate date-level totals from remaining exercises */
      const { dateSetCount, dateRepCount } = remainingExercises.reduce(
        (totals, exercise) => ({
          dateSetCount: totals.dateSetCount + (exercise.setCount || 0),
          dateRepCount: totals.dateRepCount + (exercise.repCount || 0),
        }),
        { dateSetCount: 0, dateRepCount: 0 },
      );

      return update(state, {
        nonDateBasedProgramItems: {
          [dayNumber]: {
            exercises: {
              $apply: removeByAssignedIds,
            },
            setCount: {
              $set: dateSetCount,
            },
            repCount: {
              $set: dateRepCount,
            },
          },
        },
        selectedItems: { $set: updatedSelectedItems },
        undoDeleteMetadata: {
          [[...assignedIds].sort().join(',')]: {
            $set: { kind: 'workout', dayNumber, deletedItemsWithIndices },
          },
        },
      });
    }
    case UNDO_DELETE_SAVED_WORKOUT_ITEM_FULFILLED: {
      const restoredItems = action.payload.data;
      const { assignedIds } = action.payload;
      const metadataKey = assignedIds ? [...assignedIds].sort().join(',') : null;
      const metadata = metadataKey ? state.undoDeleteMetadata[metadataKey] : null;

      if (!metadata || metadata.kind !== 'workout' || !restoredItems?.length) {
        return metadataKey
          ? update(state, { undoDeleteMetadata: { $unset: [metadataKey] } })
          : state;
      }

      const { dayNumber, deletedItemsWithIndices } = metadata;
      const exercises = [...(state.nonDateBasedProgramItems[dayNumber]?.exercises || [])];

      /** Reinsert each restored item at its original index, adjusting for any
       * items not returned by the API to keep subsequent positions correct */
      let skipped = 0;
      deletedItemsWithIndices.forEach(({ item, index }) => {
        const restoredItem = restoredItems.find((r) => r.assignedId === item.assignedId);
        if (restoredItem) {
          const insertAt = Math.min(index - skipped, exercises.length);
          exercises.splice(insertAt, 0, restoredItem);
        } else {
          skipped += 1;
        }
      });

      /** Recalculate totals */
      const { undoSetCount, undoRepCount } = exercises.reduce(
        (totals, exercise) => ({
          undoSetCount: totals.undoSetCount + (exercise.setCount || 0),
          undoRepCount: totals.undoRepCount + (exercise.repCount || 0),
        }),
        { undoSetCount: 0, undoRepCount: 0 },
      );

      return update(state, {
        nonDateBasedProgramItems: {
          [dayNumber]: {
            exercises: { $set: exercises },
            setCount: { $set: undoSetCount },
            repCount: { $set: undoRepCount },
          },
        },
        undoDeleteMetadata: { $unset: [metadataKey] },
      });
    }
    case UNDO_DELETE_SAVED_CALENDAR_ITEM_FULFILLED: {
      const restoredItems = action.payload.data;
      const { assignedIds } = action.payload;
      const metadataKey = assignedIds ? [...assignedIds].sort().join(',') : null;
      const metadata = metadataKey ? state.undoDeleteMetadata[metadataKey] : null;

      if (!metadata || metadata.kind !== 'calendar' || !restoredItems?.length) {
        return metadataKey
          ? update(state, { undoDeleteMetadata: { $unset: [metadataKey] } })
          : state;
      }

      /** Check for recurring items that have the isActiveWithWorkoutAssignment flag */
      const hasActiveWithWorkoutRecurringSchedule = Object.values(state.beforeRecurringWorkouts || {}).some(
        (arr) => arr.some((item) => item.isActiveWithWorkoutAssignment),
      )
    || Object.values(state.afterRecurringWorkouts || {}).some(
      (arr) => arr.some((item) => item.isActiveWithWorkoutAssignment),
    );

      const { date, deletedItemsWithIndices } = metadata;
      const exercises = [
        ...(state.calendarItems[date]?.exercises || []),
      ];

      /** Reinsert each restored item at its original index, adjusting for any
       * items not returned by the API to keep subsequent positions correct */
      let skipped = 0;
      deletedItemsWithIndices.forEach(({ item, index }) => {
        const restoredItem = restoredItems.find(
          (r) => r.assignedId === item.assignedId,
        );
        if (restoredItem) {
          const insertAt = Math.min(index - skipped, exercises.length);
          exercises.splice(insertAt, 0, restoredItem);
        } else {
          skipped += 1;
        }
      });

      /** Recalculate totals */
      const { undoSetCount, undoRepCount } = exercises.reduce(
        (totals, exercise) => ({
          undoSetCount: totals.undoSetCount + (exercise.setCount || 0),
          undoRepCount: totals.undoRepCount + (exercise.repCount || 0),
        }),
        { undoSetCount: 0, undoRepCount: 0 },
      );

      return update(state, {
        calendarItems: {
          [date]: {
            exercises: { $set: exercises },
            setCount: { $set: undoSetCount },
            repCount: { $set: undoRepCount },
          },
        },
        undoDeleteMetadata: { $unset: [metadataKey] },
        ...(hasActiveWithWorkoutRecurringSchedule && {
          shouldFetchRecurring: { $set: Date.now() },
        }),
      });
    }
    case UPDATE_PROGRAMMED_CALENDAR_ITEM_REJECTED: {
      return {
        ...state,
        fetchCalendarItemsError: action.payload,
      };
    }
    case REMOVE_PRESAVE_ITEM_FROM_REDUX: {
      const { date, assignedId, selectionKey } = action.payload;

      /** A removal from a save that failed after the coach switched
       * calendar/athlete belongs to the previous selection - the items it
       * targets were cleared on the switch, and a nested update on the
       * missing date would throw. */
      if (selectionKey && selectionKey !== getCalendarSelectionKey(state)) {
        return state;
      }

      const exercises = state.calendarItems[date]?.exercises || [];

      /** Clean local state for that item */
      const { [assignedId]: removed, ...remainingLocalState } = state.preSaveTableLocalState;

      const updatedExercises = exercises.filter(
        (exercise) => exercise.assignedId !== assignedId,
      );

      /** remove deleted item from selected items */
      const updatedSelectedItems = { ...state.selectedItems };
      delete updatedSelectedItems[assignedId];

      return update(state, {
        calendarItems: {
          [date]: {
            exercises: { $set: updatedExercises },
          },
        },
        selectedItems: { $set: updatedSelectedItems },
        preSaveTableLocalState: {
          $set: remainingLocalState,
        },
      });
    }
    case REMOVE_PRESAVE_PROGRAM_ITEM_FROM_REDUX: {
      const { dayNumber, assignedId, selectionKey } = action.payload;

      /** Same stale-selection guard as REMOVE_PRESAVE_ITEM_FROM_REDUX. */
      if (selectionKey && selectionKey !== getCalendarSelectionKey(state)) {
        return state;
      }

      const exercises = state.nonDateBasedProgramItems?.[dayNumber]?.exercises || [];

      /** Clean local local-state backup */
      const { [assignedId]: removed, ...remainingLocalState } = state.preSaveTableLocalState;

      /** Remove exercise by assignedId */
      const updatedExercises = exercises?.filter(
        (exercise) => exercise.assignedId !== assignedId,
      );

      /** remove deleted item from selected items */
      const updatedSelectedItems = { ...state.selectedItems };
      delete updatedSelectedItems[assignedId];

      return update(state, {
        nonDateBasedProgramItems: {
          [dayNumber]: {
            exercises: { $set: updatedExercises },
          },
        },
        selectedItems: { $set: updatedSelectedItems },
        preSaveTableLocalState: {
          $set: remainingLocalState,
        },
      });
    }
    case CLEAR_PRE_SAVE_ITEMS: {
      const payload = action.payload || {};
      const { dateKeys, dayNumbers } = payload;
      const skipIds = new Set(payload.skipAssignedIds || []);
      const filterCalendarKeys = Array.isArray(dateKeys) ? new Set(dateKeys) : null;
      const filterProgramKeys = Array.isArray(dayNumbers)
        ? new Set(dayNumbers.map((d) => String(d)))
        : null;
      const removedAssignedIds = new Set();

      const filterPreSaveFromMap = (itemsMap, restrictKeys) => {
        if (!itemsMap) return itemsMap;
        const next = {};
        Object.entries(itemsMap).forEach(([key, dayData]) => {
          if (restrictKeys && !restrictKeys.has(String(key))) {
            next[key] = dayData;
            return;
          }
          if (!dayData || !Array.isArray(dayData.exercises)) {
            next[key] = dayData;
            return;
          }
          const kept = [];
          dayData.exercises.forEach((exercise) => {
            if (exercise?.preSave && !skipIds.has(exercise.assignedId)) {
              if (exercise.assignedId) removedAssignedIds.add(exercise.assignedId);
            } else {
              kept.push(exercise);
            }
          });
          next[key] = { ...dayData, exercises: kept };
        });
        return next;
      };

      const cleanCalendarItems = filterPreSaveFromMap(state.calendarItems, filterCalendarKeys);
      const cleanProgramItems = filterPreSaveFromMap(state.nonDateBasedProgramItems, filterProgramKeys);

      const updatedSelectedItems = { ...state.selectedItems };
      const updatedLocalState = { ...state.preSaveTableLocalState };
      removedAssignedIds.forEach((id) => {
        delete updatedSelectedItems[id];
        delete updatedLocalState[id];
      });

      return {
        ...state,
        calendarItems: cleanCalendarItems,
        nonDateBasedProgramItems: cleanProgramItems,
        selectedItems: updatedSelectedItems,
        preSaveTableLocalState: updatedLocalState,
      };
    }
    case SET_DELETE_STACK: {
      return {
        ...state,
        deleteStack: action.payload,
      };
    }
    case SET_IS_DRAGGING: {
      return {
        ...state,
        isDragging: action.payload,
      };
    }
    case SET_DRAG_SOURCE: {
      return {
        ...state,
        dragSource: action.payload,
      };
    }

    case SET_PLACEHOLDER_INFO: {
      return {
        ...state,
        placeholderInfo: action.payload,
      };
    }
    case SET_DRAG_IS_IN_PROGRESS: {
      return {
        ...state,
        dragIsInProgress: action.payload,
      };
    }
    case SET_DROPPABLE_CONTAINER_CURRENTLY_HOVERED_BY_DRAGGED_ITEM: {
      return {
        ...state,
        droppableContainerCurrentlyHoveredByDraggedItem: action.payload,
      };
    }
    case SET_DRAG_CLONE_GEOMETRY: {
      return {
        ...state,
        dragCloneGeometry: action.payload,
      };
    }
    case SET_DRAGGED_ITEM: {
      return {
        ...state,
        draggedItem: action.payload,
      };
    }
    case SET_REDUX_CALENDAR_CONTAINERS: {
      return {
        ...state,
        calendarItemContainers: {
          programmedCalendarItems: action.payload.programmedCalendarItems,
          liftCalendarItems: action.payload.liftCalendarItems,
          warmUpCalendarItems: action.payload.warmUpCalendarItems,
          SAQCCalendarItems: action.payload.SAQCCalendarItems,
          circuitCalendarItems: action.payload.circuitCalendarItems,
          noteCalendarItems: action.payload.noteCalendarItems,
          questionnaireCalendarItems: action.payload.questionnaireCalendarItems,
          coolDownCalendarItems: action.payload.coolDownCalendarItems,
          healthCalendarItems: action.payload.healthCalendarItems,
          progressionCalendarItems: action.payload.progressionCalendarItems,
          tagCalendarItems: action.payload.tagCalendarItems,
          accessoryCalendarItems: action.payload.accessoryCalendarItems,
        },
      };
    }
    case SET_PROGRAMMED_CALENDAR_ITEMS: {
      return {
        ...state,
        programmedCalendarItems: action.payload,
      };
    }
    case LOG_REDUX_PRESAVE_ADD_INFO: {
      const { id, content } = action.payload;

      return {
        ...state,
        preSaveAddInfo: [
          /** Remove any existing item with the same id */
          ...state.preSaveAddInfo.filter((info) => info.id !== id),
          /** Add the new or updated info */
          { id, content },
        ],
      };
    }
    case LOG_REDUX_PRESAVE_DESCRIPTION: {
      const { id, content } = action.payload;

      return {
        ...state,
        preSaveDescription: [
          /** Remove any existing item with the same id */
          ...state.preSaveDescription.filter((desc) => desc.id !== id),
          /** Add the new or updated description */
          { id, content },
        ],
      };
    }
    case FETCH_RECURRING_CALENDAR_ITEMS_FULFILLED: {
      const requestedRange = action?.payload?.requestedRange;
      const mergedBefore = {
        ...state.beforeRecurringWorkouts,
        ...action.payload.data.beforeWorkoutsObject,
      };
      const mergedAfter = {
        ...state.afterRecurringWorkouts,
        ...action.payload.data.afterWorkoutsObject,
      };

      const earliestDateFromFetch = requestedRange?.start;
      const latestDateFromFetch = requestedRange?.end;

      return {
        ...state,
        beforeRecurringWorkouts: mergedBefore,
        afterRecurringWorkouts: mergedAfter,
        recurringItemsDateRange: {
          earliest: earliestDateFromFetch,
          latest: latestDateFromFetch,
        },
        shouldUpdateRecurring: false,
      };
    }
    case CONVERT_RECURRING_ITEM_FULFILLED: {
      /** we have to slice the item out of the calendar array
       * becuase we are converting it
       */
      const { date } = action.payload;
      const calendarActionIdUpdate = buildCalendarActionSetPatch(action.payload, state.calendarAction, state.calendarActionBatchId);

      // A successful convert ends its batch (same precedent as
      // UNDO_CALENDAR_ACTION_FULFILLED) - the item keeps the same assignedId
      // and activeExerciseId/lastActiveExerciseId are untouched here, so
      // without this, clicking back into the row hits SET_ACTIVE_EXERCISE_ID's
      // "return to same item after deactivate" branch and silently inherits
      // this batchId, lumping an unrelated later edit into the convert action.
      return update(state, {
        calendarItems: {
          [date]: {
            exercises: {
              $splice: [[action.payload.index, 1]],
            },
          },
        },
        ...calendarActionIdUpdate,
        currentBatchId: { $set: uuidv4() },
      });
    }
    case UPDATE_RECURRING_ITEM_SCHEDULE_FULFILLED: {
      // Same batch-closing precedent as CONVERT_RECURRING_ITEM_FULFILLED/
      // UNDO_CALENDAR_ACTION_FULFILLED - identical bug class (same assignedId
      // throughout, activeExerciseId untouched by this reducer case).
      const calendarActionUpdate = buildCalendarActionSetPatch(action.payload, state.calendarAction, state.calendarActionBatchId);
      return update(state, {
        ...calendarActionUpdate,
        currentBatchId: { $set: uuidv4() },
      });
    }
    case MULTI_MOVE_EXERCISE_BETWEEN_DATES_FULFILLED: {
      const {
        data, destinationDate, sourceDate,
      } = action.payload;

      const destinationDateFormatted = moment(destinationDate).format('YYYY-MM-DD');

      const sourceDateFormatted = moment(sourceDate).format('YYYY-MM-DD');

      const destinationExercises = state.calendarItems[destinationDateFormatted]?.exercises || [];

      const updatedDestinationExercises = destinationExercises.map((exercise) => {
        const match = data.find((d) => d.assignedId === exercise.assignedId);
        return match ? { ...exercise, ...match } : exercise;
      });

      /** Check for recurring items that have the isActiveWithWorkoutAssignment flag */
      const hasActiveWithWorkoutRecurringSchedule = Object.values(state.beforeRecurringWorkouts || {}).some(
        (arr) => arr.some((item) => item.isActiveWithWorkoutAssignment),
      )
    || Object.values(state.afterRecurringWorkouts || {}).some(
      (arr) => arr.some((item) => item.isActiveWithWorkoutAssignment),
    );

      /** Refined check: any active recurring items on source/destination dates */
      const sourceDateBefore = state.beforeRecurringWorkouts[sourceDateFormatted] || [];
      const destDateBefore = state.beforeRecurringWorkouts[destinationDateFormatted] || [];
      const sourceDateAfter = state.afterRecurringWorkouts[sourceDateFormatted] || [];
      const destDateAfter = state.afterRecurringWorkouts[destinationDateFormatted] || [];

      const hasActiveOnRelevantDates = [...sourceDateBefore, ...destDateBefore, ...sourceDateAfter, ...destDateAfter].some(
        (item) => item.isActiveWithWorkoutAssignment,
      );

      return update(state, {
        calendarItems: {
          [destinationDateFormatted]: {
            exercises: {
              $set: updatedDestinationExercises,
            },
          },
        },
        ...(hasActiveWithWorkoutRecurringSchedule && hasActiveOnRelevantDates && {
          shouldFetchRecurring: { $set: Date.now() },
        }),
        ...buildCalendarActionSetPatch(action.payload, state.calendarAction, state.calendarActionBatchId),
      });
    }

    case MOVE_NON_DATE_BASED_EXERCISE_BETWEEN_DAYS_FULFILLED: {
      const { data, destinationDayNumber } = action.payload;

      const destinationExercises = state.nonDateBasedProgramItems[destinationDayNumber]?.exercises || [];

      const updatedDestinationExercises = destinationExercises.map((exercise) => {
        const updatedExercise = data.find(
          (item) => item.assignedId === exercise.assignedId,
        );

        if (updatedExercise) {
          return { ...exercise, ...updatedExercise };
        }

        return exercise;
      });

      return update(state, {
        nonDateBasedProgramItems: {
          [destinationDayNumber]: {
            exercises: {
              $set: updatedDestinationExercises,
            },
          },
        },
      });
    }
    case FETCH_SAVED_WORKOUTS_FULFILLED:
      return {
        ...state,
        savedWorkouts: action.payload.data,
      };
    case FETCH_SAVED_WORKOUT_DETAIL_START:
      return {
        ...state,
        isLoadingSavedWorkout: true,
        savedWorkoutError: null,
      };
    case FETCH_SAVED_WORKOUT_DETAIL_FULFILLED:
      return {
        ...state,
        selectedSavedWorkout: action.payload.data,
        isLoadingSavedWorkout: false,
        savedWorkoutError: null,
      };
    case FETCH_SAVED_WORKOUT_DETAIL_REJECTED:
      return {
        ...state,
        isLoadingSavedWorkout: false,
        savedWorkoutError: action.payload.error,
      };
    case FETCH_SAVED_WORKOUT_FULFILLED: {
      // Drop stale responses: if the user has switched programs
      // since this request was made, the data no longer applies.
      const requestedProgramId = action.payload?.savedWorkoutId;
      const currentProgramId = state.selectedReduxNonDateBasedProgram?.id;
      if (requestedProgramId && currentProgramId && requestedProgramId !== currentProgramId) {
        return state;
      }

      const fetchedItems = action.payload.data; /** object: { [dayNumber]: item } */
      const programChanged = state.nonDateBasedProgramItemsProgramId !== action.payload.savedWorkoutId;
      const { refresh } = action.payload;
      const { weekNumber } = action.payload;

      let mergedItems = {};

      if (programChanged || refresh) {
        /** Program changed → discard local items, only use fetched */
        mergedItems = { ...fetchedItems };
      } else {
        /** Program same → preserve local items that don't conflict */
        const localItems = state.nonDateBasedProgramItems || {};

        /** Start with fetched items (fetched overrides conflicts) */
        mergedItems = { ...fetchedItems };

        /** Add non-conflicting local items */
        Object.entries(localItems).forEach(([key, value]) => {
          const isLocal = value.isLocalItem;
          const conflict = fetchedItems[key]; // key = dayNumber
          if (isLocal && !conflict) {
            mergedItems[key] = value;
          }
        });
      }

      let newSelectedDayNumber = null;

      if (refresh) {
        const items = Object.values(mergedItems);

        /** Does the passed weekNumber still exist? */
        const weekExists = items.some((item) => item.weekNumber === weekNumber);

        let targetWeek;

        if (weekExists) {
          targetWeek = weekNumber;
        } else {
          /** Find all weeks less than the deleted weekNumber */
          const previousWeeks = [];
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < items.length; i++) {
            if (items[i].weekNumber < weekNumber) {
              previousWeeks.push(items[i].weekNumber);
            }
          }

          if (previousWeeks.length === 0) {
            /** No previous weeks exist → return 0 */
            newSelectedDayNumber = 0;
          } else {
            /** Find the largest previous week */
            // eslint-disable-next-line prefer-destructuring
            targetWeek = previousWeeks[0];
            // eslint-disable-next-line no-plusplus
            for (let i = 1; i < previousWeeks.length; i++) {
              if (previousWeeks[i] > targetWeek) {
                targetWeek = previousWeeks[i];
              }
            }
          }
        }

        /** Only attempt lookup if we haven't already set result to 0 */
        if (newSelectedDayNumber !== 0) {
          let targetItem = null;
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < items.length; i++) {
            if (items[i].weekNumber === targetWeek && items[i].dayInWeek === 1) {
              targetItem = items[i];
              break;
            }
          }

          newSelectedDayNumber = targetItem ? targetItem.dayNumber : 0;
        }
      }

      const defaultObject = {
        0: {
          repCount: 0,
          setCount: 0,
          dayInWeek: 1,
          dayNumber: 0,
          weekNumber: 1,
          exercises: [],
          isLocalItem: true,
        },
      };

      let nextExpandedItems = state.expandedItems;
      Object.keys(mergedItems).forEach((dayKey) => {
        nextExpandedItems = withSessionBreaksExpanded(
          nextExpandedItems,
          mergedItems[dayKey]?.exercises,
          state.nonDateBasedProgramItems[dayKey]?.exercises,
        );
      });

      return {
        ...state,
        nonDateBasedProgramItems: Object.values(mergedItems)?.length ? mergedItems : defaultObject,
        nonDateBasedProgramItemsProgramId: action.payload.savedWorkoutId,
        /** refresh happens when a user clear a week
         * we want to set the dayNumber to the last day Number before the
         * deleted week
         */
        selectedProgramDayNumber: refresh ? newSelectedDayNumber : state.selectedProgramDayNumber,
        expandedItems: nextExpandedItems,
      };
    }
    case SET_LAST_UPDATE_TIME: {
      return {
        ...state,
        lastUpdateTime: moment(),
        // ?? (not ||) so an edited program day 0 (Week 1 Day 1) isn't collapsed to null.
        lastEditedDate: action.payload ?? null,
      };
    }
    case UPDATE_WORKOUT_INFO_NAME_FULFILLED: {
      const { formattedDate } = action.payload;

      // If calendar item exists for this date, update it
      if (state.calendarItems[formattedDate]) {
        return update(state, {
          calendarItems: {
            [formattedDate]: {
              title: {
                $set: action.payload.data.title,
              },
            },
          },
        });
      }

      // If no calendar item exists, create a new one with just the title and color
      const newCalendarItems = { ...state.calendarItems };
      newCalendarItems[formattedDate] = {
        date: formattedDate,
        title: action.payload.data.title,
        color: action.payload.data.color,
        exercises: [],
      };

      return {
        ...state,
        calendarItems: newCalendarItems,
      };
    }
    case UPDATE_NON_DATE_BASED_WORKOUT_INFO_NAME_FULFILLED: {
      const { dayNumber } = action.payload;

      // If calendar item exists for this date, update it
      if (state.nonDateBasedProgramItems[dayNumber]) {
        return update(state, {
          nonDateBasedProgramItems: {
            [dayNumber]: {
              title: {
                $set: action.payload.data.title,
              },
              color: {
                $set: action.payload.data.color,
              },
              _updatedAt: { $set: Date.now() },
            },
          },
        });
      }

      // If no calendar item exists, create a new one with just the title and color
      const newProgramItems = { ...state.nonDateBasedProgramItems };
      newProgramItems[dayNumber] = {
        dayNumber,
        title: action.payload.data.title,
        color: action.payload.data.color,
        exercises: [],
      };

      return {
        ...state,
        nonDateBasedProgramItems: newProgramItems,
      };
    }
    case UPDATE_WORKOUT_INFO_COLOR_FULFILLED: {
      const { formattedDate } = action.payload;

      // If calendar item exists for this date, update it
      if (state.calendarItems[formattedDate]) {
        return update(state, {
          calendarItems: {
            [formattedDate]: {
              color: {
                $set: action.payload.data.color,
              },
            },
          },
        });
      }

      // If no calendar item exists, create a new one with just the color and title
      const newCalendarItems = { ...state.calendarItems };
      newCalendarItems[formattedDate] = {
        date: formattedDate,
        title: action.payload.data.title || '',
        color: action.payload.data.color,
        exercises: [],
      };

      return {
        ...state,
        calendarItems: newCalendarItems,
      };
    }
    case SAVE_WORKOUT_TEMPLATE_FULFILLED: {
      return {
        ...state,
        savedWorkouts: [...state.savedWorkouts, action.payload]
          .sort((a, b) => a.programName.localeCompare(b.programName)),
      };
    }
    case SHARE_WORKOUT_INFO_START: {
      return {
        ...state,
        sharedWorkoutInfo: null,
      };
    }
    case SHARE_WORKOUT_INFO_FULFILLED: {
      return {
        ...state,
        sharedWorkoutInfo: action.payload.data,
      };
    }
    case SHARE_WORKOUT_INFO_REJECTED: {
      return {
        ...state,
        sharedWorkoutInfo: null,
      };
    }
    case REVERT_LAST_KNOWN_CORRECT_ORDER: {
      return update(state, {
        calendarItems: {
          [action.payload.date]: {
            exercises: {
              $set: action.payload.originalItems,
            },
          },
        },
      });
    }
    case REVERT_LAST_KNOWN_CORRECT_ORDER_FOR_SAVED_WORKOUT: {
      return update(state, {
        nonDateBasedProgramItems: {
          [action.payload.dayNumber]: {
            exercises: {
              $set: action.payload.originalItems,
            },
          },
        },
      });
    }
    case FETCH_CALENDAR_PICKER_ITEMS_START: {
      return state;
    }
    case FETCH_CALENDAR_PICKER_ITEMS_FULFILLED: {
      return {
        ...state,
        calendarPickerItems: action.payload.data,
      };
    }
    case FETCH_CALENDAR_PICKER_ITEMS_REJECTED: {
      return {
        ...state,
        calendarPickerItems: {},
      };
    }
    case FETCH_AND_SET_DEFAULT_CALENDAR_FULFILLED:
      return {
        ...state,
        selectedReduxCalendar: action.payload,
      };
    case FETCH_AND_SET_URL_ATHLETE_FULFILLED:
    case FETCH_AND_SET_URL_CALENDAR_FULFILLED:
    case FETCH_AND_SET_URL_CHILD_CALENDAR_FULFILLED:
    case FETCH_AND_SET_URL_PROGRAM_FULFILLED:
      // Selection state is handled by SET_SELECTED_REDUX_ATHLETE / _CALENDAR / _NON_DATE_BASED_PROGRAM
      // dispatched from the thunk — these cases exist for loading-state tracking if needed
      return state;
    case CREATE_PARENT_CALENDAR_START:
      return {
        ...state,
        calendarCreationError: null,
      };
    case CREATE_PARENT_CALENDAR_FULFILLED:
      return {
        ...state,
        selectedReduxCalendar: action.payload,
        activeModal: '',
        calendarCreationError: null,
        calendarItems: {},
        newlyCreatedCalendar: action.payload,
      };
    case CREATE_PARENT_CALENDAR_REJECTED:
      return {
        ...state,
        calendarCreationError: action.payload,
      };
    case CREATE_A_SAVED_WORKOUT_START:
      return {
        ...state,
        calendarCreationError: null,
      };
    case CREATE_A_SAVED_WORKOUT_FULFILLED:
      return {
        ...state,
        selectedReduxNonDateBasedProgram: action.payload,
        activeModal: '',
        calendarCreationError: null,
        nonDateBasedProgramItems: {},
        newlyCreatedProgram: action.payload,
      };
    case CREATE_A_SAVED_WORKOUT_REJECTED:
      return {
        ...state,
        calendarCreationError: action.payload,
      };
    case CREATE_PARENT_CHILD_CALENDAR_FULFILLED: {
      const { parentId, parentName, ...calendarData } = action.payload;

      // Create enhanced calendar object with parent info
      const enhancedCalendar = {
        ...calendarData,
        parentCalendarInfo: {
          id: parentId,
          name: parentName,
        },
      };

      return {
        ...state,
        selectedReduxCalendar: enhancedCalendar,
        activeModal: '',
        calendarCreationError: null,
        newlyCreatedCalendar: action.payload,
      };
    }
    case CREATE_PARENT_CHILD_CALENDAR_REJECTED:
      return {
        ...state,
        calendarCreationError: action.payload,
      };
    case FETCH_WORKOUT_TEMPLATE_DATA_START: {
      return {
        ...state,
        isLoadingWorkoutTemplateData: true,
        workoutTemplateDataError: null,
      };
    }
    case FETCH_WORKOUT_TEMPLATE_DATA_FULFILLED: {
      return {
        ...state,
        workoutTemplateData: action.payload.data,
        isLoadingWorkoutTemplateData: false,
        workoutTemplateDataError: null,
      };
    }
    case FETCH_WORKOUT_TEMPLATE_DATA_REJECTED: {
      return {
        ...state,
        isLoadingWorkoutTemplateData: false,
        workoutTemplateDataError: action.payload,
      };
    }
    case SET_PRESAVE_TABLE_LOCAL_STATE: {
      const { assignedId, stateObject } = action.payload;
      return {
        ...state,
        preSaveTableLocalState: {
          ...state.preSaveTableLocalState,
          [assignedId]: stateObject,
        },
      };
    }
    case REMOVE_PRESAVE_TABLE_LOCAL_STATE: {
      const { assignedId } = action.payload;
      const { [assignedId]: removed, ...remainingState } = state.preSaveTableLocalState;
      return {
        ...state,
        preSaveTableLocalState: remainingState,
      };
    }
    case CLEAR_PRESAVE_TABLE_LOCAL_STATE: {
      return {
        ...state,
        preSaveTableLocalState: {},
      };
    }
    case SET_VIEW_TYPE: {
      return {
        ...state,
        viewType: action.payload,
        /** Never carry a multi-selection across a view switch — the
         * selection model differs per view (month is day-scoped). */
        selectedItems: {},
        monthSelectionActiveDate: null,
      };
    }
    case FETCH_FUTURE_OCCURRENCES_COUNT_START: {
      return {
        ...state,
        futureOccurrencesCount: null,
      };
    }
    case FETCH_FUTURE_OCCURRENCES_COUNT_FULFILLED: {
      return {
        ...state,
        futureOccurrencesCount: action.payload.count,
      };
    }
    case FETCH_FUTURE_OCCURRENCES_COUNT_REJECTED: {
      return {
        ...state,
        futureOccurrencesCount: null,
      };
    }
    default: {
      // Handle namespaced actions for week view support
      const actionType = action.type;

      // Check if this is a namespaced action by looking for the namespace pattern
      if (actionType.includes('/')) {
        // eslint-disable-next-line no-unused-vars
        const [namespace, baseActionType] = actionType.split('/');

        switch (baseActionType) {
          case SET_CALENDAR_ITEMS_NAMESPACED: {
            // Ensure the date object exists before updating
            const dateExists = state.calendarItems[action.payload.date];
            if (!dateExists) {
              return update(state, {
                calendarItems: {
                  [action.payload.date]: {
                    $set: {
                      exercises: action.payload.calendarItemsArray,
                    },
                  },
                },
              });
            }
            return update(state, {
              calendarItems: {
                [action.payload.date]: {
                  exercises: {
                    $set: action.payload.calendarItemsArray,
                  },
                },
              },
            });
          }
          case UPDATE_CALENDAR_ITEMS_ORDER_START_NAMESPACED: {
            // Can add loading states per namespace if needed
            return state;
          }
          case UPDATE_CALENDAR_ITEMS_ORDER_FULFILLED_NAMESPACED: {
            // Handle successful reorder for namespaced actions
            return state;
          }
          case UPDATE_CALENDAR_ITEMS_ORDER_REJECTED_NAMESPACED: {
            // Handle error states per namespace if needed
            return state;
          }
          case ADD_PRESAVED_ITEM_TO_CALENDAR_ITEMS_ARRAY_NAMESPACED: {
            const { copiedItem, endpointFormattedDate, destinationIndex } = action.payload;
            const currentExercises = state.calendarItems[endpointFormattedDate]?.exercises || [];
            const newExercises = [...currentExercises];
            newExercises.splice(destinationIndex, 0, copiedItem);

            return update(state, {
              calendarItems: {
                [endpointFormattedDate]: {
                  exercises: {
                    $set: newExercises,
                  },
                },
              },
            });
          }
          case SET_COMBINE_WITH_INFO_NAMESPACED: {
            return {
              ...state,
              combineWithInfo: action.payload.combineInfo,
            };
          }
          default:
            return state;
        }
      }

      return {
        ...state,
      };
    }
  }
}
